import { abrePDF } from "../../../utils/pdf";
import React, { useState, useEffect, useContext, useMemo } from "react";
import { fDMA } from "../../../utils/fecha";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Badge,
  Spinner,
  Form,
  UncontrolledTooltip,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import { ean13ToDataURL } from "../../../utils/ean13";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import BajaMultiple from "../../BajaMultiple";
import StatusMultiple from "../../StatusMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import CurrencyInput from "react-currency-input-field";
import { formatValue } from "react-currency-input-field";
import moment from "moment";

import { v4 as uuidv4 } from "uuid";
import AutorizadoMultiple from "../../AutorizadoMultiple";

function ListadoPedidos() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const PASSWORD_CAMBIA_PRECIO = process.env.REACT_APP_PASSWORD_CAMBIA_PRECIO;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_ARTICULOS_PROPORCION = process.env.REACT_APP_URL_ARTICULOS_PROPORCION;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 122);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [articulos, setArticulos] = useState([]);

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [paqueteria, setPaqueteria] = useState("");
  const [paqueterias, setPaqueterias] = useState([]);
  const [fechaProgramadaEdit, setFechaProgramadaEdit] = useState("");
  // V4 detalle: market edit filtros + catálogo marcas/lineas
  const [marcasEditMarket, setMarcasEditMarket] = useState([]);
  const [lineasEditMarket, setLineasEditMarket] = useState([]);
  const [marketSearch, setMarketSearch] = useState("");
  const [marketFiltroMarca, setMarketFiltroMarca] = useState("");
  const [marketFiltroLinea, setMarketFiltroLinea] = useState("");
  const URL_FOTO_CLOUDINARY = process.env.REACT_APP_URL_FOTO_CLOUDINARY;
  const SIN_IMAGEN_MKT = process.env.PUBLIC_URL + "/sinImagen.png";
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [fecha, setFecha] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [total_general, setTotalGeneral] = useState(0);
  const [total_cantidad, setTotalCantidad] = useState(0);
  const [numero_pedido, setNumeroPedido] = useState("");

  const [idEdit, setIdEdit] = useState("");
  const [currentEditPedidoRow, setCurrentEditPedidoRow] = useState(null);
  const [selectedClienteEdit, setSelectedClienteEdit] = useState("");
  const [selectedColaboradorEdit, setSelectedColaboradorEdit] = useState("");
  const [comisionTDC, setComisionTDC] = useState(0);
  const [comisionFlete, setComisionFlete] = useState(0);
  const [selectedImpuesto, setSelectedImpuesto] = useState(0);
  const [iva, setIva] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [surtido, setSurtido] = useState("");
  const [nombreClienteEdit, setNombreClienteEdit] = useState("");
  const [idClienteEdit, setIdClienteEdit] = useState("");
  const [fechaModificado, setFechaModificado] = useState("");

  const [articulosPedido, setArticulosPedido] = useState([]);
  const [total_general_edit, setTotalGeneralEdit] = useState(0);
  const [total_cantidad_edit, setTotalCantidadEdit] = useState(0);
    const [descuento, setDescuento] = useState(0);
    const [descuentoNumero, setDescuentoNumero] = useState(0);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [validaBoton, setValidaBoton] = useState(true);

  // A2: lista de precios en modal editar artículos
  const [listaPreciosEdit, setListaPreciosEdit] = useState(1);
  // Vista market al editar: mismos datos que PedidosCreateMarket
  const URL_ARTICULOS_EMBARQUES = process.env.REACT_APP_URL_ARTICULOS_EMBARQUES;
  const [pendRecibirMkt, setPendRecibirMkt] = useState({}); // idArticulo -> {pendiente_recibir, proximaLlegada}

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      piezasPorCaja: 0,
      cajas: 0,
      cantidad: 0,
      precio: 0,
      descuento: 0,
      total: 0,
    },
  ]);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  // Valores originales de los artículos al abrir la edición (para saber
  // cuáles cambiaron y marcarlos como editados).
  const [articulosPedidoOriginal, setArticulosPedidoOriginal] = useState([]);

  // Modal de solo lectura para visualizar el pedido sin poder editarlo
  const [modalVer, setModalVer] = useState(false);
  const toggleVer = () => setModalVer(!modalVer);
  const [verPedido, setVerPedido] = useState(null);
  const [verArticulos, setVerArticulos] = useState([]);
  const [verCargando, setVerCargando] = useState(false);

  const [modalNoDisponible, setModalNoDisponible] = useState(false);
  const toggleNoDisponible = () => setModalNoDisponible(!modalNoDisponible);
  const [allArticulosAutorizar, setAllArticulosAutorizar] = useState([]);

  const [inventarios, setInventarios] = useState([]);

  const [status, setStatus] = useState("Abierto");
  const [autorizadoApartado, setAutorizadoApartado] = useState("");
  const [autorizadoSurtido, setAutorizadoSurtido] = useState("");

  const [cambiarPrecio, setCambiarPrecio] = useState(false);
  const [modalCambiaPrecio, setModalCambiaPrecio] = useState(false);
  const toggleCambiaPrecio = () => setModalCambiaPrecio(!modalCambiaPrecio);
  const [password, setPassword] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  // Listado completo ya filtrado (sin paginar): lo usan PDF, Excel y totales
  const [datosFiltrados, setDatosFiltrados] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const [AbrirEditar, setAbrirEditar] = useState(false);
  const [vistaMarketEdit, setVistaMarketEdit] = useState(false);

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    axios
      .get(`${URL_PEDIDOS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allPedidos = response.data;

        if (user.vendedor === "Si") {
          allPedidos = allPedidos.filter(pedido => pedido.colaboradores?.[0]?.email === user.email);
        }
        // console.log("hola", allPedidos)
        // Array para pagination
        let arrayTabla = allPedidos
          .sort((a, b) => (a.idPedido < b.idPedido ? 1 : -1))
          .map((a) => {
            const cli = a.clientes?.[0] || {};
            const colab = a.colaboradores?.[0] || {};
            return {
              _id: a._id,
              numero: a.idPedido,
              activo: a.is_active,
              fecha: a.fecha,
              colaboradores: (colab.nombre || "Sin") + " " + (colab.apellido || "vendedor"),
              idColaboradores: colab._id || "",
              observaciones: a.observaciones,
              subTotal: a.subTotal,
              iva: a.iva,
              total_general: a.total_general,
              clientes: cli.nombre_comercial || "NA",
              idClientes: cli._id || "",
              total_cantidad: a.total_cantidad,
              status: a.status,
              autorizadoApartado: a.autorizadoApartado,
              autorizadoSurtido: a.autorizadoSurtido,
              comisionTDC: a.comisionTDC,
              comisionFlete: a.comisionFlete,
              impuestos: a.impuestos,
              descuento: a.descuento,
              listaPrecios: a.listaPrecios || 1,
              paqueteria: a.paqueteria,
              surtido: a.surtido,
              codigoClientes: cli.codigo || "",
              calle: cli.calle || "",
              numero_ext: cli.numero_ext || "",
              numero_int: cli.numero_int || "",
              pais: cli.pais || "",
              estado: cli.estado || "",
              ciudad: cli.ciudad || "",
              delegacion: cli.delegacion || "",
              colonia: cli.colonia || "",
              cp: cli.cp || "",
              RFC: cli.RFC || "",
              fechaModificado: a.fechaModificado,
              telefono: cli.telefono || "",
              editado: a.editado,
              editPedido: a.editPedido,
              autorizoApartado: a.autorizoApartado,
              autorizoSurtido: a.autorizoSurtido,
              fechaInicio: a.fechaInicio,
              fechaCancelacion: a.fechaCancelacion,
              fecha_programada: a.fecha_programada || "",
              piezasEntregadas: a.piezasEntregadas,
              piezasPendientes: a.total_cantidad - a.piezasEntregadas,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let data = Object.values(arrayTabla);
        setComments(data);
        //
      })
      .catch((err) => {
        console.log(err);
      });

 
  }, [user, selectedFechaInicio, selectedFechaFin]);

  useEffect(() => {
    axios
    .get(`${URL_CLIENTES}GeneralActivos`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allClientes = response.data;
      setClientes(allClientes);
    })
    .catch((err) => {
      console.log(err);
    });

  axios
    .get(URL_COLABORADORES, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allColaboradores = response.data;
      setColaboradores(allColaboradores);
    })
    .catch((err) => {
      console.log(err);
    });

  axios
    .get(process.env.REACT_APP_URL_PAQUETERIAS, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((res) => setPaqueterias((res.data || []).filter((p) => p.is_active !== "No")))
    .catch(() => setPaqueterias([]));

  axios
    .get(`${URL_ARTICULOS}Activos`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allArticulos = response.data;
      setArticulos(allArticulos);
    })
    .catch((err) => {
      console.log(err);
    });

  axios
    .get(process.env.REACT_APP_URL_MARCAS, {
      headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
    })
    .then((res) => setMarcasEditMarket(res.data || []))
    .catch(() => setMarcasEditMarket([]));

  axios
    .get(process.env.REACT_APP_URL_LINEAS, {
      headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
    })
    .then((res) => setLineasEditMarket(res.data || []))
    .catch(() => setLineasEditMarket([]));

  axios
    .get(`${URL_INVENTARIOS}Disponible`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allDisponible = response.data;
      setInventarios(allDisponible);
    })
    .catch((err) => {
      console.log(err);
    });

  // Por recibir por artículo (mercancía en camino), para la tarjeta del market
  axios
    .get(`${URL_ARTICULOS_EMBARQUES}PendRecibirAgrupado`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      const pr = {};
      (response.data || []).forEach((d) => {
        pr[d.idArticulo] = {
          pendiente_recibir: Number(d.pendiente_recibir || 0),
          proximaLlegada: d.proximaLlegada || "",
        };
      });
      setPendRecibirMkt(pr);
    })
    .catch(() => setPendRecibirMkt({}));
  }, []);

  // === Totales del listado filtrado ===
  // Las cotizaciones canceladas no suman importes ni piezas.
  const vivas = (datosFiltrados || []).filter((a) => a.activo !== "No");
  const sumar = (campo) =>
    vivas.reduce((t, a) => t + (Number(a[campo]) || 0), 0);
  const totPiezas = sumar("total_cantidad");
  const totSurtidas = sumar("piezasEntregadas");
  const totPendientes = sumar("piezasPendientes");
  const totSubTotal = sumar("subTotal");
  const totIva = sumar("iva");
  const totGeneral = sumar("total_general");

function PDFTabla() {
  // Usa el listado ya filtrado en pantalla: respeta TODOS los filtros
  // (búsqueda incluida) y el orden actual.
  const money = (n) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    }).format(Number(n) || 0);
  const num = (n) => new Intl.NumberFormat("en-US").format(Number(n) || 0);

  const dataPDFLimpia = datosFiltrados.map((a) => {
    const cancelado = a.activo === "No";
    return [
      a.numero,
      a.fecha,
      a.fechaInicio,
      a.fechaCancelacion,
      a.clientes,
      a.colaboradores,
      cancelado ? "Cancelado" : num(a.total_cantidad),
      cancelado ? "" : num(a.piezasEntregadas),
      cancelado ? "" : num(a.piezasPendientes),
      a.autorizadoSurtido,
      cancelado ? "" : money(a.subTotal),
      cancelado ? "" : money(a.iva),
      cancelado ? "Cancelado" : money(a.total_general),
    ];
  });

  const doc = new jsPDF("landscape", "mm", "a4", true);
  var img2 = new Image();
  img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
  doc.addImage(img2, "png", 120, 10, 35, 18);

  doc.setFontSize(12);
  doc.text(`Listado Cotizaciones`, 14, 30);
  doc.setFontSize(9);
  doc.text(`${selectedFechaInicio} - ${selectedFechaFin}   ·   Cotizaciones: ${datosFiltrados.length}`, 14, 37);
  doc.text(
    `Piezas: ${num(totPiezas)}   Surtidas: ${num(totSurtidas)}   Pendientes: ${num(totPendientes)}   SubTotal: ${money(totSubTotal)}   IVA: ${money(totIva)}   Total: ${money(totGeneral)}`,
    14,
    43
  );

  doc.autoTable({
    head: [[
      "Numero", "Fecha", "Fecha Inicio", "Fecha Cancelacion", "Cliente",
      "Vendedor", "Piezas", "Surtidas", "Pendientes", "Aut. Surtido",
      "SubTotal", "IVA", "Total",
    ]],
    body: dataPDFLimpia,
    foot: [[
      "", "", "", "", "", "TOTALES",
      num(totPiezas), num(totSurtidas), num(totPendientes), "",
      money(totSubTotal), money(totIva), money(totGeneral),
    ]],
    headStyles: { fillColor: ["#911c04"], lineWidth: 0, fontSize: 7, halign: "center" },
    footStyles: { fillColor: ["#911c04"], fontSize: 7, halign: "right" },
    bodyStyles: { fontSize: 7 },
    columnStyles: {
      6: { halign: "right" }, 7: { halign: "right" }, 8: { halign: "right" },
      10: { halign: "right" }, 11: { halign: "right" }, 12: { halign: "right" },
    },
    theme: "grid",
    startY: 48,
    margin: { left: 8, right: 8 },
  });

  abrePDF(doc, `Cotizaciones.pdf`);
}

  function excel() {
    // Mismo listado filtrado que la pantalla, con todas las columnas
    const dataExcelLimpia = datosFiltrados.map((a) => {
      const cancelado = a.activo === "No";
      return {
        Numero: a.numero,
        Fecha: a.fecha,
        FechaInicio: a.fechaInicio,
        FechaCancelacion: a.fechaCancelacion,
        Cliente: a.clientes,
        Vendedor: a.colaboradores,
        Estatus: cancelado ? "Cancelado" : a.status,
        Piezas: cancelado ? 0 : Number(a.total_cantidad) || 0,
        PiezasSurtidas: cancelado ? 0 : Number(a.piezasEntregadas) || 0,
        PiezasPendientes: cancelado ? 0 : Number(a.piezasPendientes) || 0,
        AutSurtido: a.autorizadoSurtido,
        SubTotal: cancelado ? 0 : Number(a.subTotal) || 0,
        IVA: cancelado ? 0 : Number(a.iva) || 0,
        Total: cancelado ? 0 : Number(a.total_general) || 0,
      };
    });

    // Renglón de totales al final
    dataExcelLimpia.push({
      Numero: "",
      Fecha: "",
      FechaInicio: "",
      FechaCancelacion: "",
      Cliente: "",
      Vendedor: "TOTALES",
      Estatus: "",
      Piezas: totPiezas,
      PiezasSurtidas: totSurtidas,
      PiezasPendientes: totPendientes,
      AutSurtido: "",
      SubTotal: totSubTotal,
      IVA: totIva,
      Total: totGeneral,
    });

    const columnas = [
      "Numero", "Fecha", "FechaInicio", "FechaCancelacion", "Cliente",
      "Vendedor", "Estatus", "Piezas", "PiezasSurtidas", "PiezasPendientes",
      "AutSurtido", "SubTotal", "IVA", "Total",
    ];

    var option = {};
    option.fileName = `ListadoCotizaciones-${selectedFechaInicio}-${selectedFechaFin}`;
    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoCotizaciones",
        sheetFilter: columnas,
        sheetHeader: [
          "Numero", "Fecha", "Fecha Inicio", "Fecha Cancelacion", "Cliente",
          "Vendedor", "Estatus", "Piezas", "Piezas Surtidas", "Piezas Pendientes",
          "Aut. Surtido", "SubTotal", "IVA", "Total",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (status == 0 || status == a.status) &&
        (autorizadoApartado == 0 ||
          autorizadoApartado == a.autorizadoApartado) &&
        (autorizadoSurtido == 0 || autorizadoSurtido == a.autorizadoSurtido) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (selectedColaborador == 0 || selectedColaborador == a.idColaboradores)
      ) {
        return [
          a.numero,
          a.fecha,
          a.colaboradores,
          a.clientes,
          a.total_cantidad,
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.total_general),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();

    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 35, 18);
    doc.text(`Listado Ordenes de Compra`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Numero", "Fecha", "Vendedor", "Cliente", "Cantidad", "Total"]],
      body: dataPDFLimpia,
      headStyles: {
        fillColor: ["#911c04"],
        lineWidth: 0,
      },
      footStyles: {
        fillColor: ["#911c04"],
      },
      theme: "grid",
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Cotizaciones",
          email: mailTo,
          fileName: "ListadoCotizaciones.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Cotizaciones.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  // ¿El pedido ya está autorizado para surtir? Sólo en ese caso una edición
  // se marca como "modificado" (y pinta el renglón en el listado de surtir).
  function esAutorizadoSurtir(idPedido) {
    const p = (comments || []).find((c) => c._id === idPedido);
    return p?.autorizadoSurtido === "Si";
  }

  function jalaInfo(
    fecha,
    idColaboradores,
    idClientes,
    total_cantidad,
    total_general,
    observaciones,
    numero_pedido,
    comisionTDC,
    comisionFlete,
    impuestos,
    paqueteria,
    idEdit
  ) {
    setFecha(fecha);
    setSelectedColaboradorEdit(idColaboradores);
    setSelectedClienteEdit(idClientes);
    setTotalCantidad(total_cantidad);
    setTotalGeneral(total_general);
    setObservaciones(observaciones);
    setNumeroPedido(numero_pedido);
    setComisionTDC(comisionTDC);
    setComisionFlete(comisionFlete);
    setSelectedImpuesto(impuestos);

    setPaqueteria(paqueteria);
    setIdEdit(idEdit);
    toggleEdit();
  }

  // Abre el pedido en modo consulta (sin inputs, sin guardar).
  // Disponible para cualquier pedido: abierto, cerrado, surtido o cancelado.
  async function verPedidoDetalle(a) {
    setVerPedido(a);
    setVerArticulos([]);
    setVerCargando(true);
    toggleVer();
    try {
      const resp = await axios.get(`${URL_ARTICULOS_PEDIDO}/pedidos/${a._id}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      });
      const rows = (resp.data || []).map((x) => {
        const art = x.articulos?.[0] || {};
        return {
          id: x._id,
          is_active: x.is_active,
          codigo: art.codigo || "",
          nombre: art.nombre || "",
          cantidad: Number(x.cantidad || 0),
          precio: Number(x.precio || 0),
          descuento: Number(x.descuento || 0),
          total: Number(x.total || 0),
          pendiente_surtir: Number(x.pendiente_surtir || 0),
        };
      });
      setVerArticulos(rows);
    } catch (err) {
      console.error("[verPedidoDetalle]", err);
      Swal.fire({ icon: "error", title: "Error", text: "No se pudieron cargar los artículos" });
    } finally {
      setVerCargando(false);
    }
  }

  async function duplicarPedido(pedidoId) {
    try {
      const conf = await Swal.fire({
        title: "Duplicar pedido",
        text: "¿Quieres crear un nuevo pedido con las mismas líneas?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí, duplicar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#911c04",
      });
      if (!conf.isConfirmed) return;
      const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
      // Obtener el pedido original
      const orig = (await axios.get(`${URL_PEDIDOS}/${pedidoId}`, { headers })).data;
      const articulos = (await axios.get(`${URL_ARTICULOS_PEDIDO}/pedidos/${pedidoId}`, { headers })).data;
      const hoy = new Date().toISOString().slice(0, 10);
      // Crear nuevo pedido (copia mutable de los campos editables)
      const newPedido = {
        fecha: hoy,
        clientes: orig.clientes?.[0]?._id || orig.clientes?.[0],
        sucursales: orig.sucursales?.[0]?._id || orig.sucursales?.[0] || (orig.clientes?.[0]?._id || orig.clientes?.[0]),
        colaboradores: orig.colaboradores?.[0]?._id || orig.colaboradores?.[0],
        areas: orig.areas?.[0]?._id || orig.areas?.[0],
        observaciones: `${orig.observaciones || ""} (duplicado)`,
        total_general: orig.total_general,
        subTotal: orig.subTotal,
        iva: orig.iva,
        impuestos: orig.impuestos,
        total_cantidad: orig.total_cantidad,
        paqueteria: orig.paqueteria || "NA",
        comisionTDC: orig.comisionTDC || 0,
        comisionFlete: orig.comisionFlete || 0,
        descuento: orig.descuento || 0,
        autorizadoApartado: "No",
        autorizadoSurtido: "No",
        surtido: "No",
        editado: "No",
        fecha_estimada: hoy,
        fecha_entrega: hoy,
        entregaInsumos: "No",
        fechaInicio: hoy,
        fechaCancelacion: hoy,
        fechaModificado: hoy,
        creado: user.id,
        piezasEntregadas: 0,
        piezasPendientes: orig.total_cantidad || 0,
      };
      const resp = await axios.post(URL_PEDIDOS, newPedido, { headers });
      const nuevoId = resp.data._id;
      // Duplicar líneas
      for (const ap of articulos) {
        await axios.post(URL_ARTICULOS_PEDIDO, {
          pedidos: nuevoId,
          articulos: ap.articulos?.[0]?._id || ap.articulos?.[0],
          cantidad: ap.cantidad,
          cantidadProcesos: 0,
          surtido: 0,
          pendiente_surtir: ap.cantidad,
          precio: Number(ap.precio).toFixed(2),
          total: Number(ap.total).toFixed(2),
          autorizadoSurtido: "No",
          autorizadoApartado: "No",
          clientes: ap.clientes?.[0]?._id || ap.clientes?.[0],
          fecha: hoy,
        }, { headers });
      }
      Swal.fire({ icon: "success", title: "Pedido duplicado", text: `Nuevo pedido #${resp.data.idPedido || ""}` });
      setTimeout(() => window.location.reload(), 1200);
    } catch (e) {
      console.error(e);
      Swal.fire({ icon: "error", title: "Error al duplicar", text: e.response?.data?.message || e.message });
    }
  }

  async function PDFBarrasOC(pedidoId, numero, clienteName) {
    try {
      const res = await axios.get(`${URL_ARTICULOS_PEDIDO}/surtir2/${pedidoId}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      });
      const items = res.data || [];
      if (items.length === 0) {
        Swal.fire({ icon: "info", title: "Pedido sin articulos" });
        return;
      }
      const doc = new jsPDF({ compressPdf: true });
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      doc.text(`Pedido #${numero} - Codigos de Barras`, 14, 18);
      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      doc.text(`Cliente: ${clienteName || ""}`, 14, 25);

      const body = items.map((a) => {
        const art = a.articulos?.[0] || {};
        const cant = Number(a.cantidad || 0);
        const ppc = Number(art.piezasPorCaja || 0);
        const cajas = ppc > 0 ? (cant / ppc).toFixed(2) : "-";
        const ean = String(art.EAN || "").replace(/[^0-9]/g, "");
        const dataUrl = ean
          ? ean13ToDataURL(ean, { moduleWidth: 2, height: 50, textSize: 14 })
          : null;
        return {
          articulo: `${art.codigo || ""} ${art.nombre || ""}`,
          cantidad: cant,
          cajas,
          ean,
          dataUrl,
        };
      });

      doc.autoTable({
        head: [["Articulo", "Cantidad", "Cajas", "Codigo Barras"]],
        body: body.map((b) => [b.articulo, b.cantidad, b.cajas, ""]),
        startY: 32,
        bodyStyles: { rowHeight: 16, valign: "middle" },
        styles: { fontSize: 9, cellPadding: 1.5 },
        headStyles: {
          fillColor: "#911c04",
          textColor: "#ffffff",
          halign: "center",
        },
        columnStyles: {
          0: { cellWidth: 90 },
          1: { halign: "center", cellWidth: 22 },
          2: { halign: "center", cellWidth: 22 },
          3: { cellWidth: 45, halign: "center" },
        },
        didDrawCell: function (data) {
          if (data.column.index === 3 && data.cell.section === "body") {
            const row = body[data.row.index];
            if (row?.dataUrl) {
              try {
                // Imagen centrada y proporcional dentro de la celda
                const imgW = data.cell.width - 4;
                const imgH = data.cell.height - 4;
                const x = data.cell.x + 2;
                const y = data.cell.y + 2;
                doc.addImage(row.dataUrl, "PNG", x, y, imgW, imgH);
              } catch (e) {
                console.log("EAN13 error", e);
              }
            } else if (row?.ean) {
              doc.setFontSize(8);
              doc.text(
                `EAN invalido: ${row.ean}`,
                data.cell.x + data.cell.width / 2,
                data.cell.y + data.cell.height / 2,
                { align: "center", baseline: "middle" }
              );
            } else {
              doc.setFontSize(8);
              doc.text(
                "Sin EAN",
                data.cell.x + data.cell.width / 2,
                data.cell.y + data.cell.height / 2,
                { align: "center", baseline: "middle" }
              );
            }
          }
        },
      });

      abrePDF(doc, `Pedido-${numero}-CodigosBarras.pdf`);
    } catch (err) {
      console.log(err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo generar el PDF de codigos de barras",
      });
    }
  }

  // C9: PDF enfocado en peso (pesoPieza + pesoCaja de Articulos)
  async function PDFPeso(idPedido, numero, clienteName, fecha) {
    try {
      const res = await axios.get(`${URL_ARTICULOS_PEDIDO}/surtir2/${idPedido}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      });
      const filas = (res.data || [])
        .filter((a) => a?.articulos?.[0])
        .map((a) => {
          const art = a.articulos[0];
          const cantidad = Number(a.cantidad || 0);
          const pesoPieza = Number(art.pesoPieza || 0);
          const pesoCaja = Number(art.pesoCaja || 0);
          const pxc = Number(art.piezasPorCaja || 1) || 1;
          const cajas = cantidad / pxc;
          const pesoTotal = cantidad * pesoPieza;
          return {
            idArticulo: art._id,
            codigo: art.codigo || "",
            nombre: art.nombre || "",
            cantidad,
            cajas,
            pesoPieza,
            pesoCaja,
            pesoTotal,
          };
        });
      const grupos = {};
      for (const f of filas) {
        const id = String(f.idArticulo);
        grupos[id] = grupos[id] || { ...f, cantidad: 0, cajas: 0, pesoTotal: 0 };
        grupos[id].cantidad += f.cantidad;
        grupos[id].cajas += f.cajas;
        grupos[id].pesoTotal += f.pesoTotal;
      }
      const rows = Object.values(grupos)
        .sort((a, b) => (a.codigo || "").localeCompare(b.codigo || ""))
        .map((g) => [
          g.codigo,
          g.nombre,
          new Intl.NumberFormat("en-US").format(g.cantidad),
          new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(g.cajas),
          new Intl.NumberFormat("en-US", { maximumFractionDigits: 3 }).format(g.pesoPieza) + " kg",
          new Intl.NumberFormat("en-US", { maximumFractionDigits: 3 }).format(g.pesoCaja) + " kg",
          new Intl.NumberFormat("en-US", { maximumFractionDigits: 3 }).format(g.pesoTotal) + " kg",
        ]);
      const totalPiezas = Object.values(grupos).reduce((t, g) => t + g.cantidad, 0);
      const totalCajas = Object.values(grupos).reduce((t, g) => t + g.cajas, 0);
      const totalPeso = Object.values(grupos).reduce((t, g) => t + g.pesoTotal, 0);

      const doc = new jsPDF("portrait", "mm", "a4", true);
      const img = new Image();
      img.src = process.env.PUBLIC_URL + "logoInstitucion.png";
      doc.addImage(img, "png", 15, 8, 33, 20);
      doc.setFontSize(12);
      doc.text(`Cotización por Peso`, 105, 20, { align: "center" });
      doc.setFontSize(9);
      doc.text(`Cliente: ${clienteName || ""}`, 15, 34);
      doc.text(`Cotización: ${numero || ""}   Fecha: ${fecha || ""}`, 15, 40);

      doc.autoTable({
        head: [["Código", "Descripción", "Cantidad", "Cajas", "Peso Pieza", "Peso Caja", "Peso Total"]],
        body: rows,
        startY: 45,
        theme: "grid",
        styles: { fontSize: 8 },
        headStyles: { fillColor: [176, 35, 7], textColor: 255, halign: "center", fontSize: 8 },
        columnStyles: {
          2: { halign: "right" },
          3: { halign: "right" },
          4: { halign: "right" },
          5: { halign: "right" },
          6: { halign: "right" },
        },
        foot: [[
          "", "Totales",
          new Intl.NumberFormat("en-US").format(totalPiezas),
          new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(totalCajas),
          "", "",
          new Intl.NumberFormat("en-US", { maximumFractionDigits: 3 }).format(totalPeso) + " kg",
        ]],
        footStyles: { fillColor: [176, 35, 7], textColor: 255, fontSize: 8 },
      });
      abrePDF(doc, `Peso-${numero || idPedido}.pdf`);
    } catch (err) {
      console.log(err);
      Swal.fire({ icon: "error", title: "Error", text: "No se pudo generar el PDF de peso" });
    }
  }

  async function PDFOC(
    fecha,
    colaboradores,
    idClientes,
    clientes,
    total_cantidad,
    total_general,
    observaciones,
    numero,
    impuestos,
    descuento,
    comisionFlete,
    comisionTDC,
    idPDFOC,
    calle,
    numero_ext,
    numero_int,
    pais,
    estado,
    ciudad,
    delegacion,
    colonia,
    cp,
    RFC,
    paqueteria,
    codigoClientes,
    autorizadoApartado,
    autorizadoSurtido,
    telefono,
    editado,
    editPedido,
    autorizoApartado,
    autorizoSurtido,
    subtotal,
    iva,
    conImagenes = true
  ) {
    console.log(subtotal, iva, descuento)
    await axios
      .get(`${URL_ARTICULOS_PEDIDO}/surtir2/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then(async(response) => {
        let allArticulosPedido = response.data;
    let arrayTabla = await Promise.all(allArticulosPedido.map(async (a) => {
    const idArticulo = a.articulos[0]._id;
    let coloresNombres = "";

    try {
        const articulosProporcionResponse = await axios.get(
            `${URL_ARTICULOS_PROPORCION}Articulos/${idArticulo}`,
            {
                headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
            }
        );

        const coloresIds = articulosProporcionResponse.data.flatMap(item => item.colores);

        if (coloresIds.length > 0) {
            const colores = coloresIds.map(c => c.name);
            const coloresUnicos = [...new Set(colores)];
            coloresNombres = coloresUnicos.join(", ");
        } else {
            coloresNombres = "Sin Color";
        }
    } catch (err) {
        console.log(`Error obteniendo colores para el artículo ${idArticulo}:`, err);
        coloresNombres = "Error al obtener colores";
    }

    return {
        id: a._id,
        articulos: a.articulos[0].codigo + " " + a.articulos[0].nombre,
        nombreArticulo: a.articulos[0].nombre || "",
        linea: a.articulos[0].lineas?.[0]?.name || "Sin Categoria",
        subLinea: a.articulos[0].subLineas?.[0]?.name || "",
        idArticulo: idArticulo,
        fotoArticulo: a.articulos[0].foto,
        cantidad: a.cantidad,
        surtido: a.surtido,
        precio: a.precio,
        total: a.total,
        descuento: a.descuento || 0,
        // Renglón modificado al editar el pedido: se pinta de amarillo en el PDF
        editado: a.editado || "No",
        pendiente_surtir: a.pendiente_surtir,
        cajas: a.cantidad / a.articulos[0].piezasPorCaja,
        autorizoApartado: a.pedidos[0].autorizoApartado,
        autorizoSurtido: a.pedidos[0].autorizoSurtido,
        colores: coloresNombres,
        foto: "",
    };
}));

// Z4: ordenar por Categoria (linea) → SubCategoria → nombre (igual que Lista PDF)
arrayTabla.sort((a, b) => {
  if (a.linea !== b.linea) return (a.linea || "").localeCompare(b.linea || "");
  if ((a.subLinea || "") !== (b.subLinea || "")) return (a.subLinea || "").localeCompare(b.subLinea || "");
  return (a.nombreArticulo || "").localeCompare(b.nombreArticulo || "");
});



        let dataFinal = Object.values(arrayTabla);

        let totalKG = dataFinal.map((c) => parseFloat(c.cantidad));
        let TK = totalKG.reduce((t, total, index) => t + total, 0);

        let importes = dataFinal.map((c) => parseFloat(c.total));
        let TG = importes.reduce((t, total, index) => t + total, 0);

        let TC = dataFinal.map((c) => parseFloat(c.cajas));
        let TTC = TC.reduce((t, total, index) => t + total, 0);

        let iva_tabla = (TG * impuestos) / 100;

        if (conImagenes) {
          dataFinal.map(async (z) => {
            if (z.fotoArticulo == "Si") {
              const URL_GET_MEDIA = `${process.env.REACT_APP_URL_GETMEDIA}/${z.idArticulo}`;
              await axios
                .get(URL_GET_MEDIA, {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                })
                .then((data) => {
                  if (data.data.secure_url != null) {
                    z.foto = data.data.secure_url;
                  } else z.foto = process.env.PUBLIC_URL + "sinImagen.png";
                })
                .catch((err) => {
                  console.log(err);
                });
              return z;
            } else {
              z.foto = process.env.PUBLIC_URL + "sinImagen.png";
            }
          });
        } else {
          dataFinal.forEach((z) => {
            z.foto = "";
          });
        }

        setTimeout(() => {
          const hayDescuentos = dataFinal.some((d) => parseFloat(d.descuento || 0) > 0);
          const data = dataFinal.map((a) => {
            const cols = [
              a.foto,
              a.articulos,
              new Intl.NumberFormat("en-US").format(a.cantidad),
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(a.precio),
            ];
            if (hayDescuentos) {
              cols.push(parseFloat(a.descuento || 0) > 0 ? `${parseFloat(a.descuento).toFixed(2)}%` : "-");
            }
            cols.push(
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(a.total)
            );
            return conImagenes ? cols : cols.slice(1);
          });

          const dataPDF = Object.values(data);
          const dataPDFLimpia = dataPDF.filter(function (el) {
            return el != null;
          });

          const colImg = {
            fontSize: 0.000001,
            textColor: [255, 255, 255],
            cellWidth: 20,
          };
          const colStylesBase = [
            { fontSize: 9, textColor: ["#000000"] },
            // { fontSize: 9, textColor: ["#000000"] },
            { fontSize: 9, textColor: ["#000000"], halign: "center" },
            { fontSize: 9, textColor: ["#000000"], halign: "center" },
            { fontSize: 9, textColor: ["#000000"], halign: "right" },
            { fontSize: 9, textColor: ["#000000"], halign: "right" },
          ];
          const columnStyles = conImagenes
            ? [colImg, ...colStylesBase]
            : colStylesBase;

          const doc = new jsPDF({ compressPdf: true });
          var img = new Image();

          var img2 = new Image();
          const backgroundColor = ["#d1d2d4"];
          const backgroundColorBoxLightGray = ["#e6e7e9"];
          const backgroundColorBoxBlack = ["#231f20"];
          const backgroundColorBoxPurple = ["#911c04"];
          const margins = { left: 5, right: 5 };

          img.src = process.env.PUBLIC_URL + "logoInstitucion.png";
          doc.addImage(img, "png", 15, 5, 33, 20);

          // img.src = process.env.PUBLIC_URL + "marcas.png";
          // doc.addImage(img, "png", 9, 28, 192, 10);
          // doc.setFontSize(10);

          doc.setFillColor(...backgroundColor);
          doc.rect(5, 40, 200, 6, "F");
          doc.setTextColor("#000000");
          doc.setFontSize(10);
          // doc.text(`Tel: 55 1234 5678`, 8, 44);

          doc.setTextColor("#000000");

          doc.text(`Cliente: ${clientes}`, 8, 52);
          doc.text(
            `Dirección: ${calle} ${numero_ext} ${numero_int} ${estado} ${ciudad} ${cp}`,
            8,
            57
          );
          doc.text(`Vendedor: ${colaboradores}`, 8, 62);      
          doc.setFontSize(12);
          doc.setFont("helvetica", "bold");
          // doc.text(`Cotizacion numero ${numero}, no es una orden de venta`, 105, 52);

          // doc.setTextColor("#911c04");
          // doc.setFontSize(12);
          // doc.setFont("helvetica", "bold");
          // doc.text(`macuro.mx`, 175, 44);
          // doc.setTextColor("#000000");

          doc.setFontSize(14);
          // Un solo recuadro con borde (sin relleno) abarcando el área
          doc.setDrawColor(0);
          doc.setLineWidth(0.3);
          doc.rect(74, 4, 131, 22);
          doc.setTextColor("#000000");
          doc.setFont("helvetica", "bold");
          doc.text(`COTIZACIÓN # ${numero}`, 125, 12);
          doc.setFont("helvetica", "normal");
          doc.text(`México, D. F. a ${fecha}`, 125, 22);

          // V7: si alguna línea tiene descuento, agregar columna DESC % (hayDescuentos ya definido arriba)
          const headBase = hayDescuentos
            ? ["PRODUCTO", "CANTIDAD", "PRECIO", "DESC %", "IMPORTE"]
            : ["PRODUCTO", "CANTIDAD", "PRECIO", "IMPORTE"];
          const headFinal = conImagenes ? ["", ...headBase] : headBase;

          doc.autoTable({
            head: [headFinal],
            body: dataPDFLimpia,
            bodyStyles: {
              rowHeight: conImagenes ? 22 : 8,
              valign: "middle",
            },
            styles: {
              fontSize: 10,
              // overflow: "linebreak",
              // columnWidth: "wrap",
              // // font: 'arial',
              // overflowColumns: "linebreak",
            },
            headStyles: {
              fillColor: ["#911c04"],
              lineWidth: 0,
              halign: "center",
              valign: "middle",
              fontSize: 8,
            },
            footStyles: {
              fillColor: ["#911c04"],
            },
            columnStyles: columnStyles,
            theme: "grid",
            margin: { left: 5, right: 5 },
            startY: 70,

            didDrawCell: function (data) {
              if (
                conImagenes &&
                data.column.index === 0 &&
                data.cell.section === "body"
              ) {
                var td = data.cell.raw;
                if (!td) return;
                var img = td;
                var textPos = data.cell;
                try {
                  doc.addImage(img, textPos.x, textPos.y, 20, 20);
                } catch (e) {
                  console.log("No se pudo agregar imagen", e);
                }
              }
            },

            showFoot: "lastPage",
          });

          let finalY = doc.autoTable.previous.finalY;
const pageHeight = doc.internal.pageSize.height;
const espacioNecesario = 120;

if (finalY + espacioNecesario > pageHeight) {
  doc.addPage();
  finalY = 10;
}

          doc.setFillColor(...backgroundColorBoxPurple);
          doc.rect(5, finalY + 1, 36, 6, "F");
          doc.setTextColor("#ffffff");
          doc.setFontSize(8);
          doc.text(`TOTAL DE ARTICULOS`, 7, finalY + 5);
          doc.setTextColor("#000000");
          // doc.text(
          //   `________________________________________________________________________________________________________________________________`,
          //   5,
          //   finalY + 30
          // );

          doc.setFillColor(...backgroundColorBoxLightGray);
          doc.setFont("helvetica", "normal");
          doc.rect(40, finalY + 1, 40, 6, "F");
          doc.text(
            new Intl.NumberFormat("en-US").format(TK) + " Piezas",
            42,
            finalY + 5
          );

          doc.setFontSize(7.5);
          doc.text(
            `- Esto es una cotización por lo que precios y cantidades esta sujetas a modificaciones.`,
            5,
            finalY + 11
          );
          doc.text(
            `- Antes de generar un pago, se debe confirmar precios y cantidades surtidas ya que estas pueden variar.`,
            5,
            finalY + 14
          );
          // doc.text(
          //   `3. El pago de la mercancía debe realizarse en tiempo y forma pactados a la cuenta proporcionada por nosotros.`,
          //   5,
          //   finalY + 17
          // );

          doc.setFillColor(...backgroundColorBoxPurple);
          doc.rect(144, finalY + 1, 37, 6, "F");
          doc.setTextColor("#ffffff");
          doc.setFont("helvetica", "bold");
          doc.setFontSize(8);
          doc.text(`SUBTOTAL $`, 153, finalY + 5);

          doc.setFillColor(...backgroundColorBoxLightGray);
          doc.setTextColor("#000000");
          doc.setFont("helvetica", "normal");
          doc.rect(181, finalY + 1, 24, 6, "F");
          doc.text(
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(subtotal.toFixed(2)),
            183,
            finalY + 5
          );

          doc.setFillColor(...backgroundColorBoxPurple);
          doc.rect(144, finalY + 8, 37, 6, "F");
          doc.setTextColor("#ffffff");
          doc.setFont("helvetica", "bold");
          doc.setFontSize(8);
          doc.text(`FLETE $`, 153, finalY + 12);

          doc.setFillColor(...backgroundColorBoxLightGray);
          doc.setTextColor("#000000");
          doc.setFont("helvetica", "normal");
          doc.rect(181, finalY + 8, 24, 6, "F");
          doc.text(
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
            }).format(comisionFlete),
            183,
            finalY + 12
          );

          // V7 detalle: el descuento ya se muestra por renglón en la tabla. Quitar del totales.

          doc.setFillColor(...backgroundColorBoxPurple);
          doc.rect(144, finalY + 15, 37, 6, "F");
          doc.setTextColor("#ffffff");
          doc.setFont("helvetica", "bold");
          doc.setFontSize(8);
          doc.text(`IMPUESTO $`, 153, finalY + 19);

          doc.setFillColor(...backgroundColorBoxLightGray);
          doc.setTextColor("#000000");
          doc.setFont("helvetica", "normal");
          doc.rect(181, finalY + 15, 24, 6, "F");
          doc.text(
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
            }).format(iva),
            183,
            finalY + 19
          );

          doc.setFillColor(...backgroundColorBoxPurple);
          doc.rect(144, finalY + 22, 37, 6, "F");
          doc.setTextColor("#ffffff");
          doc.setFont("helvetica", "bold");
          doc.setFontSize(8);
          doc.text(`TOTAL $`, 153, finalY + 26);

          doc.setFillColor(...backgroundColorBoxLightGray);
          doc.setTextColor("#000000");
          doc.setFont("helvetica", "normal");
          doc.rect(181, finalY + 22, 24, 6, "F");
          doc.text(
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(total_general.toFixed(2)),
            183,
            finalY + 26
          );

          var lines = doc.splitTextToSize(
            `Observaciones: ${observaciones}`,
            40
          );
          doc.text(145, finalY + 33, lines);

          abrePDF(doc, `Pedido-${numero}.pdf`);
        }, 1000);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function excelOC(id, numero) {
    await axios
      .get(`${URL_ARTICULOS_PEDIDO}/surtir2/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosPedido = response.data;
        let arrayTabla = allArticulosPedido
          .map((a) => {
            return {
              Articulos: a.articulos[0].codigo + " " + a.articulos[0].nombre,
              Cantidad:
                a.cantidad +
                " Pzas. / " +
                a.cantidad / a.articulos[0].piezasPorCaja +
                " Cajas",
              Surtido: a.surtido,
              PendSurtir: a.pendiente_surtir,
              Cajas: a.cantidad / a.articulos[0].piezasPorCaja,
              Precio: a.precio,
              Importe: a.total,
              Surtido: a.surtido,
              Pendiente_Surtir: a.pendiente_surtir,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        const dataExportExcel = Object.values(arrayTabla);
        const dataExcelLimpia = dataExportExcel.filter(function (el) {
          return el != null;
        });

        var option = {};

        option.fileName = `Pedido ${numero}`;

        option.datas = [
          {
            sheetData: dataExcelLimpia,
            sheetName: `Pedido ${numero}`,
            sheetFilter: [
              "Articulos",
              "Cantidad",
              "Surtido",
              "PendSurtir",
              "Precio",
              "Importe",
            ],
            sheetHeader: [
              "Articulos",
              "Cantidad",
              "Surtido",
              "PendSurtir",
              "Precio",
              "Importe",
            ],
          },
        ];

        var toExcel = new ExportJsonExcel(option);
        toExcel.saveExcel();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function editPedidos(event) {
    event.preventDefault();
    const URL_PEDIDOS_EDIT = `${URL_PEDIDOS}/${idEdit}`;

    axios
      .patch(
        URL_PEDIDOS_EDIT,
        {
          observaciones,
          editPedido: user.id,
          paqueteria,
          fecha_programada: fechaProgramadaEdit,
          ...(selectedClienteEdit ? { clientes: selectedClienteEdit } : {}),
          // Sólo se marca como modificado si el pedido YA estaba autorizado
          // para surtir: antes de eso, editarlo es parte del flujo normal y
          // no hay nada que avisarle a almacén.
          ...(esAutorizadoSurtir(idEdit)
            ? { editado: "Si", tipoEdicion: "datos" }
            : {}),
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Pedido",
            detalle: `${numero_pedido} ${fecha}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );

        toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    // { name: "Activo", field: "activo", sortable: true },
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Fecha Inicio", field: "fechaInicio", sortable: true },
    { name: "Fecha Cancelacion", field: "fechaCancelacion", sortable: true },
    { name: "Cliente", field: "clientes", sortable: true },
    { name: "Vendedor", field: "colaboradores", sortable: true },
    { name: "Piezas", field: "total_cantidad", sortable: true },
    { name: "Piezas surtidas", field: "piezasEntregadas", sortable: true },
    { name: "Piezas Pendientes", field: "piezasPendientes", sortable: true },
    { name: "Aut. Surtido", field: "autorizadoSurtido", sortable: true },
    { name: "SubTotal", field: "subTotal", sortable: true },
    { name: "IVA", field: "iva", sortable: true },
    { name: "Total", field: "total_general", sortable: true },
    // Acciones en dos columnas: lo que autoriza o cambia el estado del pedido
    // por un lado, y lo que lo edita o imprime por el otro.
    { name: "Autorización", field: "accionesAut", sortable: false },
    { name: "Edición / PDF", field: "accionesEdit", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.colaboradores.toLowerCase().includes(search.toLowerCase()) ||
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.total_cantidad.toString().includes(search) ||
          // comment.total_general.toString().includes(search) ||
          comment.numero.toString().includes(search)
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idClientes.includes(selectedCliente)
      );
    }
    if (selectedColaborador) {
      computedComments = computedComments.filter((e) =>
        e.idColaboradores.includes(selectedColaborador)
      );
    }
    if (status) {
      if (status === "Cancelado") {
        computedComments = computedComments.filter((e) => e.activo === "No");
      } else {
        computedComments = computedComments.filter((e) =>
          (e.status || "").includes(status) && e.activo !== "No"
        );
      }
    }
    if (autorizadoSurtido) {
      computedComments = computedComments.filter((e) =>
        e.autorizadoSurtido.includes(autorizadoSurtido)
      );
    }
    if (autorizadoApartado) {
      computedComments = computedComments.filter((e) =>
        e.autorizadoApartado.includes(autorizadoApartado)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "total_cantidad" &&
      // sorting.field != "total_general" &&
      sorting.field != "piezasEntregadas" &&
      sorting.field != "piezasPendientes" &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "total_cantidad" ||
        // sorting.field == "total_general" ||
        sorting.field == "piezasEntregadas" ||
        sorting.field == "piezasPendientes" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "total_cantidad" ||
        // sorting.field == "total_general" ||
        sorting.field == "piezasEntregadas" ||
        sorting.field == "piezasPendientes" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    // Listado COMPLETO ya filtrado y ordenado (sin paginar). Lo consumen el
    // PDF, el Excel y los totales, para que siempre reflejen exactamente lo
    // que se ve en pantalla y no una copia de los filtros que se desfase.
    setDatosFiltrados(computedComments);

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCliente,
    selectedColaborador,
    status,
    selectedFechaInicio,
    selectedFechaFin,
    autorizadoApartado,
    autorizadoSurtido,
  ]);

  function EditArticulos(
    idOC,
    numero_pedido,
    comisionTDC,
    comisionFlete,
    impuestos,
    subTotal,
    iva,
    total_general,
    total_cantidad,
    surtido,
    clientes,
    idClientes,
    fechaModificado,
    fecha,
    descuento,
    listaPrecios
  ) {
    setComisionTDC(comisionTDC);
    setComisionFlete(comisionFlete);
    setSelectedImpuesto(impuestos);
    setSurtido(surtido);
    setIva(iva.toFixed(2));
    setTotalGeneralEdit(total_general);
    setTotalCantidadEdit(total_cantidad);
    setSubTotal(subTotal);
    setNombreClienteEdit(clientes);
    setIdClienteEdit(idClientes);
    setFechaModificado(fechaModificado);
    setFecha(fecha);
    setDescuento(descuento);
    setDescuentoNumero((subTotal * descuento) / 100)

    setInputFields([
      {
        id: uuidv4(),
        articulos: "",
        piezasPorCaja: 0,
        cajas: 0,
        cantidad: 0,
        precio: 0,
        total: 0,
      },
    ]);
    setIdEdit(idOC);
    setNumeroPedido(numero_pedido);
    axios
      .get(`${URL_ARTICULOS_PEDIDO}/pedidos/${idOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosPedido = response.data;
        let arrayTabla = allArticulosPedido
          .map((a) => {
            return {
              id: a._id,
              is_active: a.is_active,
              articulos: a.articulos[0]._id,
              cantidad: a.cantidad,
              surtido: a.surtido,
              precio: a.precio,
              descuento: a.descuento || 0,
              total: a.total,
              pendiente_surtir: a.pendiente_surtir,
              piezasPorCaja: a.articulos[0].piezasPorCaja,
              cajas: a.cantidad / a.articulos[0].piezasPorCaja,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setArticulosPedido(dataFinal);
        // Snapshot de los valores originales para detectar, al guardar, qué
        // renglones cambiaron y marcarlos como editados.
        setArticulosPedidoOriginal(
          dataFinal.map((x) => ({
            id: x.id,
            cantidad: Number(x.cantidad) || 0,
            precio: Number(x.precio) || 0,
            descuento: Number(x.descuento) || 0,
          }))
        );
        // A2: cargar lista guardada, si no viene inferir comparando el precio
        // del primer artículo con las listas del artículo real
        if (Number(listaPrecios) > 0) {
          setListaPreciosEdit(Number(listaPrecios));
        } else {
          const primero = dataFinal.find((x) => x.is_active === "Si") || dataFinal[0];
          if (primero) {
            const art = allArticulosPedido.find((a) => a._id === primero.id)?.articulos?.[0];
            const precio = Number(primero.precio);
            const eq = (a, b) => Math.abs(Number(a || 0) - Number(b || 0)) < 0.01;
            let inferida = 1;
            if (art) {
              if (eq(art.lista1, precio)) inferida = 1;
              else if (eq(art.lista2, precio)) inferida = 2;
              else if (eq(art.lista3, precio)) inferida = 3;
              else if (eq(art.lista4, precio)) inferida = 4;
              else if (eq(art.lista5, precio)) inferida = 5;
            }
            setListaPreciosEdit(inferida);
          } else {
            setListaPreciosEdit(1);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
    setAbrirEditar(true);
  }

  const handleChangeInputExistentesPrecio = (id, event) => {
    const newArticulosPedido = articulosPedido.map((i) => {
      if (id === i.id) {
        i.precio = event;
        const descPct = parseFloat(i.descuento) || 0;
        let totalParcial = i.cantidad * i.precio * (1 - descPct / 100);
        i.total = totalParcial;
        i.pendiente_surtir = i.cantidad - i.surtido;
      }
      return i;
    });
    setArticulosPedido(newArticulosPedido);
    ActualizaTotales(newArticulosPedido, inputFields);
  };

  function BuscaArticuloExistentes(id, event) {
    if (
      inputFields.filter((e) => e.articulos == event.target.value).length > 0 ||
      articulosPedido.filter((e) => e.articulos == event.target.value).length >
        0
    ) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "El modelo ya fue capturado!",
        showConfirmButton: false,
      });
      // const newInputFields = inputFields.map((i) => {
      //   if (id === i.id) {
      //     i.articulos = "";
      //   }
      //   return i;
      // });
      // setInputFields(newInputFields);
    } else {
      articulos.map((a) => {
        if (a._id == event.target.value) {
          let idArticulo = a._id;
          let piezasPorCaja = a.piezasPorCaja;
          handleChangeInputExistentesArticulo(id, idArticulo, piezasPorCaja);
        }
      });
    }
  }

  const handleChangeInputExistentesArticulo = (
    id,
    idArticulo,
    piezasPorCaja
  ) => {
    const newArticulosPedido = articulosPedido.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.piezasPorCaja = piezasPorCaja;
        const descPct = parseFloat(i.descuento) || 0;
        let totalParcial = i.cantidad * i.precio * (1 - descPct / 100);
        i.total = totalParcial;
        i.pendiente_surtir = i.cantidad - i.surtido;
      }
      return i;
    });
    setArticulosPedido(newArticulosPedido);
    ActualizaTotales(newArticulosPedido, inputFields);
  };

  const handleChangeInputCajasExistentes = (id, event) => {
    const newArticulosPedido = articulosPedido.map((i) => {
      if (id === i.id) {
        i.cajas = event.target.value;
        i.cantidad =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        const descPct = parseFloat(i.descuento) || 0;
        let totalParcial = i.cantidad * i.precio * (1 - descPct / 100);
        i.total = totalParcial;
        i.pendiente_surtir =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja) -
          parseFloat(i.surtido);
      }
      return i;
    });
    setArticulosPedido(newArticulosPedido);
    ActualizaTotales(newArticulosPedido, inputFields);
  };

  const handleChangeInputCantidadExistentes = (id, event) => {
    const newArticulosPedido = articulosPedido.map((i) => {
      if (id === i.id) {
        i.cantidad = parseFloat(event.target.value);
        i.cajas = parseFloat(event.target.value) / parseFloat(i.piezasPorCaja);
        const descPct = parseFloat(i.descuento) || 0;
        let totalParcial = i.cantidad * i.precio * (1 - descPct / 100);
        i.total = totalParcial;
        i.pendiente_surtir =
          parseFloat(event.target.value) - parseFloat(i.surtido);
      }
      return i;
    });
    setArticulosPedido(newArticulosPedido);
    ActualizaTotales(newArticulosPedido, inputFields);
  };

  const handleChangeInputCajas = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.cajas = event.target.value;
        i.cantidad =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        const descPct = parseFloat(i.descuento) || 0;
        let totalParcial = i.cantidad * i.precio * (1 - descPct / 100);
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales(articulosPedido, newInputFields);
  };

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.cantidad = event.target.value;
        i.cajas = parseFloat(event.target.value) / parseFloat(i.piezasPorCaja);
        const descPct = parseFloat(i.descuento) || 0;
        let totalParcial = i.cantidad * i.precio * (1 - descPct / 100);
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales(articulosPedido, newInputFields);
  };

  const handleAddFields = () => {
    const ultimo = inputFields[inputFields.length - 1];
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: "",
        piezasPorCaja: 0,
        cajas: 0,
        cantidad: 0,
        precio: 0,
        total: 0,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let KG = articulosPedido.concat(values);
    let totalKG = KG.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalCantidadEdit(TK);

    let importesExistentes = articulosPedido.map((c) => parseFloat(c.total));
    let importesNuevos = values.map((c) => parseFloat(c.total));
    let importes = importesExistentes.concat(importesNuevos);
    let TG = importes.reduce((t, total, index) => t + total, 0);

    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * (TG - descuentoNumero)) / 100);
    } else {
      setIva(0);
    }
    setTotalGeneralEdit(
      (selectedImpuesto * (TG - descuentoNumero)) / 100 +
        TG +
        parseFloat(comisionTDC) +
        parseFloat(comisionFlete)
    );
  };

  const handleChangeInputPrecio = (id, value) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.precio = value;
        const descPct = parseFloat(i.descuento) || 0;
        let totalParcial = i.cantidad * value * (1 - descPct / 100);
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales(articulosPedido, newInputFields);
  };

  function BuscaArticulo(id, event) {
    if (
      inputFields.filter((e) => e.articulos == event.target.value).length > 0 ||
      articulosPedido.filter((e) => e.articulos == event.target.value).length >
        0
    ) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "El modelo ya fue capturado!",
        showConfirmButton: false,
      });
      const newInputFields = inputFields.map((i) => {
        if (id === i.id) {
          i.articulos = "";
        }
        return i;
      });
      setInputFields(newInputFields);
    } else {
      articulos.map((a) => {
        if (a._id == event.target.value) {
          let idArticulo = a._id;
          let piezasPorCaja = a.piezasPorCaja;
          let precio = a.venta;
          handleChangeInputArticulo(id, idArticulo, piezasPorCaja, precio);
        }
      });
    }
  }

  const handleChangeInputArticulo = (id, idArticulo, piezasPorCaja, precio) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.piezasPorCaja = piezasPorCaja;
        i.precio = precio;
        const descPct = parseFloat(i.descuento) || 0;
        let totalParcial = i.cantidad * i.precio * (1 - descPct / 100);
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales(articulosPedido, newInputFields);
  };

  // FIX: `ActualizaTotales` puede recibir los arrays actualizados como parámetro
  // para evitar leer state "viejo" del closure inmediatamente después de un
  // `setArticulosPedido`/`setInputFields`. Sin esto, cambiar precio/cantidad/
  // descuento de una línea existente dejaba el subTotal desfasado y el pedido
  // se guardaba con totales incorrectos.
  function ActualizaTotales(apOverride, ifOverride) {
    let DESC = 0
    let ivaTT = 0
    const apSrc = apOverride ?? articulosPedido;
    const ifSrc = ifOverride ?? inputFields;
    let activos = apSrc.filter((e) => e.is_active == "Si");
    let activos2 = activos.concat(ifSrc);
    let cantidadActivos = activos2.map((c) => parseFloat(c.cantidad));
    let TA = cantidadActivos.reduce((t, total, index) => t + total, 0);
    setTotalCantidadEdit(TA);

    let totalActivos = activos2.map((c) => parseFloat(c.total));
    let TG = totalActivos.reduce((t, total, index) => t + total, 0);
    setSubTotal(TG.toFixed(2));

    if (descuento != 0) {
      DESC = (TG * descuento) / 100;
    }else{
      DESC = 0
    }

    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * (TG - DESC)) / 100);
      ivaTT = (selectedImpuesto * (TG - DESC)) / 100
    } else {
      setIva(0);
    }


    setTotalGeneralEdit(TG + ivaTT + comisionFlete + comisionTDC - DESC);
    setFechaModificado(endDate);
  }
  function calculaDescuento(e) {
    setDescuento(e);
    let temp1 = (subTotal * e) / 100;

    setDescuentoNumero(temp1);

    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * (subTotal - temp1)) / 100);
    } else {
      setIva(0);
    }
    
    let temp = subTotal - temp1;

    let totTemp = temp + parseFloat(comisionTDC) + parseFloat(comisionFlete)+ parseFloat((selectedImpuesto * (subTotal - temp1)) / 100);

    setTotalGeneralEdit(totTemp);
  }
  const savePedido = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    toggleProgreso();
    const URL_PEDIDOS_EDIT = `${URL_PEDIDOS}/${idEdit}`;
    // Se calcula una sola vez: define si esta edición se marca como modificada
    const marcarModificado = esAutorizadoSurtir(idEdit);
    const auth = {
      headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
    };

    // ORDEN IMPORTANTE: primero los renglones, al final el encabezado.
    // Antes se guardaba el encabezado (subTotal / iva / total) ANTES de tocar
    // los renglones, y los renglones se mandaban sin esperar y con los errores
    // silenciados. Si uno fallaba, el pedido quedaba con un total que no
    // correspondía a sus artículos. Ahora, si algo falla, se aborta antes de
    // escribir el encabezado y el total sigue siendo el que ya estaba.
    try {
      // El amarillo (en el renglón de Pendiente Surtir y en el PDF) es una
      // señal para ALMACÉN: le dice que cambió lo que tiene que surtir. Un
      // cambio de precio o de descuento no mueve piezas, así que no debe
      // pintarlo. Se decide aquí, una vez, y aplica igual al renglón y al
      // encabezado del pedido.
      const cambioCantidad = (ap) => {
        const orig = articulosPedidoOriginal.find((o) => o.id === ap.id);
        return !orig || (Number(ap.cantidad) || 0) !== orig.cantidad;
      };
      const nuevos = inputFields.filter(
        (a) => a.articulos !== "" && Number(a.cantidad) !== 0
      );
      const huboCambioDeSurtido =
        articulosPedido.filter((ap) => ap.id).some(cambioCantidad) ||
        nuevos.length > 0;

      // 1) Renglones que ya existían
      await Promise.all(
        articulosPedido
          .filter((ap) => ap.id)
          .map((ap) => {
            const cambio = cambioCantidad(ap);
            return axios.patch(
              `${URL_ARTICULOS_PEDIDO}/${ap.id}`,
              {
                articulos: ap.articulos,
                cantidad: parseFloat(ap.cantidad) || 0,
                precio: parseFloat(ap.precio) || 0,
                descuento: parseFloat(ap.descuento) || 0,
                total: parseFloat(ap.total) || 0,
                ...(ap.pendiente_surtir !== undefined
                  ? { pendiente_surtir: parseFloat(ap.pendiente_surtir) || 0 }
                  : {}),
                // Una vez marcado se conserva; solo se agregan marcas nuevas.
                ...(cambio && marcarModificado ? { editado: "Si" } : {}),
              },
              auth
            );
          })
      );

      // 2) Renglones agregados durante la edición (`nuevos` se calculó arriba)
      await Promise.all(
        nuevos.map((a) =>
          axios.post(
            URL_ARTICULOS_PEDIDO,
            {
              pedidos: idEdit,
              articulos: a.articulos,
              cantidad: parseFloat(a.cantidad),
              cantidadProcesos: 0,
              precio: parseFloat(a.precio),
              descuento: parseFloat(a.descuento) || 0,
              total: parseFloat(a.total).toFixed(2),
              surtido: 0,
              pendiente_surtir: parseFloat(a.cantidad),
              // Artículo agregado durante la edición: se marca sólo
              // si el pedido ya estaba autorizado para surtir
              ...(marcarModificado ? { editado: "Si" } : {}),
              clientes: idClienteEdit,
              fecha,
            },
            auth
          )
        )
      );

      // 3) Encabezado: sólo cuando TODOS los renglones quedaron guardados
      await axios.patch(
        URL_PEDIDOS_EDIT,
        {
          total_general: parseFloat(total_general_edit).toFixed(2),
          total_cantidad: total_cantidad_edit,
          piezasPendientes: total_cantidad_edit,
          editArticulos: user.id,
          comisionTDC,
          comisionFlete,
          subTotal: parseFloat(subTotal).toFixed(2),
          iva: parseFloat(iva).toFixed(2),
          impuestos: selectedImpuesto,
          // Sólo se marca modificado si ya estaba autorizado para surtir Y
          // cambió alguna cantidad o se agregó un renglón. Antes bastaba con
          // guardar: un cambio de precio pintaba el pedido en Pendiente Surtir.
          ...(marcarModificado && huboCambioDeSurtido
            ? { editado: "Si", tipoEdicion: "articulos", fechaModificado }
            : {}),
          descuento,
          listaPrecios: listaPreciosEdit,
        },
        auth
      );

      // 4) Bitácora y cierre
      try {
        await axios.post(
          URL_LOGS,
          { tipo: "Editar Pedido", detalle: `${numero_pedido}`, user: user.id },
          auth
        );
      } catch (error) {
        console.log("log Editar Pedido:", error);
      }

      Swal.fire("Good job!", "Editado con exito", `success`);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.log("error editando el pedido:", error);
      Swal.fire({
        icon: "error",
        title: "No se guardó el pedido",
        text:
          "No se pudieron guardar todos los artículos, así que el total del pedido no se modificó. Vuelve a intentar.",
        footer: `${error?.response?.data?.message || ""}`,
      });
      setValidaBoton(true);
      toggleProgreso();
    }
  };

  function calculaImpuesto(e) {
    setSelectedImpuesto(e);
    if (e != 0) {
      setIva((e * (subTotal - descuentoNumero)) / 100);
    } else {
      setIva(0);
    }
    setTotalGeneralEdit(
      (e * subTotal) / 100 +
        subTotal +
        parseFloat(comisionTDC) +
        parseFloat(comisionFlete) -
        parseFloat(descuentoNumero)
    );
  }

  function jalaComisionTDC(e) {
    setComisionTDC(e);
    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * (subTotal - descuentoNumero)) / 100);
    } else {
      setIva(0);
    }
    setTotalGeneralEdit(
      (selectedImpuesto * (subTotal - descuentoNumero)) / 100 +
        subTotal +
        parseFloat(e) +
        parseFloat(comisionFlete) -
        parseFloat(descuentoNumero)
    );
  }

  function jalaComisionFlete(e) {
    setComisionFlete(e);
    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * (subTotal - descuentoNumero)) / 100);
    } else {
      setIva(0);
    }
    setTotalGeneral(
      (selectedImpuesto * (subTotal - descuentoNumero)) / 100 +
        subTotal -
        parseFloat(descuentoNumero) +
        parseFloat(comisionTDC) +
        parseFloat(e)
    );
  }

  function autorizaCambio() {
    if (password == PASSWORD_CAMBIA_PRECIO) {
      setCambiarPrecio(true);
      toggleCambiaPrecio();
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La contraseña es incorrecta!",
      });
    }
  }

  function bajaArticulo(id) {
    const URL_AUTORIZADO_HIJO = `${URL_ARTICULOS_PEDIDO}/autorizadoApartado/${idEdit}`;
    const temp = articulosPedido.map((i) => {
      if (id === i.id) {
        i.is_active = "No";
      }
      return i;
    });

    Swal.fire({
      title: "Estas seguro?",
      text: "Se dara de baja!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, dar de Baja!",
    }).then((result) => {
      if (result.isConfirmed) {
        let activos = temp.filter((e) => e.is_active == "Si");
        let cantidadActivos = activos.map((c) => parseFloat(c.cantidad));
        let TA = cantidadActivos.reduce((t, total, index) => t + total, 0);
        setTotalCantidadEdit(TA);

        let totalActivos = activos.map((c) => parseFloat(c.total));
        let TG = totalActivos.reduce((t, total, index) => t + total, 0);
        setSubTotal(TG);

        let IT;
        if (selectedImpuesto != 0) {
          IT = (selectedImpuesto * TG) / 100;
        } else {
          IT = 0;
        }

        setIva(IT);

        let TGT =
          (selectedImpuesto * TG) / 100 +
          TG +
          parseFloat(comisionTDC) +
          parseFloat(comisionFlete);

        setTotalGeneralEdit(TGT.toFixed(2));

        axios
          .patch(
            `${URL_ARTICULOS_PEDIDO}/${id}`,
            {
              is_active: "No",
              autorizadoApartado: "No",
              autorizadoSurtido: "No",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            //Patch Pedidos
            axios
              .patch(
                `${URL_PEDIDOS}/${idEdit}`,
                {
                  total_cantidad: TA,
                  total_general: TGT,
                  subTotal: TG,
                  iva: IT,
                  autorizadoApartado: "No",
                  autorizadoSurtido: "No",
                  autorizoApartado: user.id,
                  fechaModificado: hoy,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                axios
                  .patch(
                    URL_AUTORIZADO_HIJO,
                    {
                      autorizadoApartado: "No",
                      autorizadoSurtido: "No",
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    const newAP = articulosPedido.map((i) => {
                      if (id === i.id) {
                        i.is_active = "No";
                      }
                      return i;
                    });
                    setArticulosPedido(newAP);

                    const newPed = comments.map((i) => {
                      if (idEdit === i._id) {
                        i.total_cantidad = TA;
                        i.total_general = TGT;
                        i.subTotal = TG;
                        i.iva = IT;
                        i.autorizadoApartado = "No";
                        i.autorizadoSurtido = "No";
                      }
                      return i;
                    });
                    setComments(newPed);

                    Swal.fire({
                      position: "center",
                      icon: "success",
                      title: "Se dio de Baja",
                      showConfirmButton: false,
                      timer: 2000,
                    });
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                  });
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
            //Termina Patch Pedidos
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  function altaArticulo(id) {
    const temp = articulosPedido.map((i) => {
      if (id === i.id) {
        i.is_active = "Si";
      }
      return i;
    });

    Swal.fire({
      title: "Estas seguro?",
      text: "Se dara de Alta!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, dar de Alta!",
    }).then((result) => {
      if (result.isConfirmed) {
        let activos = temp.filter((e) => e.is_active == "Si");
        let cantidadActivos = activos.map((c) => parseFloat(c.cantidad));
        let TA = cantidadActivos.reduce((t, total, index) => t + total, 0);
        setTotalCantidadEdit(TA);

        let totalActivos = activos.map((c) => parseFloat(c.total));
        let TG = totalActivos.reduce((t, total, index) => t + total, 0);
        setSubTotal(TG);

        let IT;
        if (selectedImpuesto != 0) {
          IT = (selectedImpuesto * TG) / 100;
        } else {
          IT = 0;
        }

        setIva(IT);

        let TGT =
          (selectedImpuesto * TG) / 100 +
          TG +
          parseFloat(comisionTDC) +
          parseFloat(comisionFlete);

        setTotalGeneralEdit(TGT.toFixed(2));

        axios
          .patch(
            `${URL_ARTICULOS_PEDIDO}/${id}`,
            {
              is_active: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            //Patch Pedidos
            axios
              .patch(
                `${URL_PEDIDOS}/${idEdit}`,
                {
                  total_cantidad: TA,
                  total_general: TGT,
                  subTotal: TG,
                  iva: IT,
                  autorizadoApartado: "Si",
                  autorizadoSurtido: "Si",
                  autorizoApartado: user.id,
                  fechaModificado: hoy,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then((response) => {
                const newAP = articulosPedido.map((i) => {
                  if (id === i.id) {
                    i.is_active = "Si";
                  }
                  return i;
                });
                setArticulosPedido(newAP);

                const newPed = comments.map((i) => {
                  if (idEdit === i._id) {
                    i.total_cantidad = TA;
                    i.total_general = TGT;
                    i.subTotal = TG;
                    i.iva = IT;
                    i.autorizadoApartado = "Si";
                    i.autorizadoSurtido = "Si";
                  }
                  return i;
                });
                setComments(newPed);

                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Se dio de Alta",
                  showConfirmButton: false,
                  timer: 2000,
                });
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
            //Termina Patch Pedidos
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  function desautorizarSurtido(id, ped) {
    const URL_AUTORIZADO = `${URL_PEDIDOS}/${id}`;
    const URL_AUTORIZADO_HIJO = `${URL_ARTICULOS_PEDIDO}/autorizadoSurtido/${id}`;
    Swal.fire({
      title: "Estas seguro?",
      text: "Se quitara la autorizacion de Surtir!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, quitar autorizacion!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            URL_AUTORIZADO,
            {
              autorizadoSurtido: "No",
              autorizadoApartado: "No",
              autorizoSurtido: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .patch(
                URL_AUTORIZADO_HIJO,
                {
                  autorizadoSurtido: "No",
                  autorizadoApartado: "No",
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                axios.post(
                  URL_LOGS,
                  {
                    tipo: "Desautorizar Surtido",
                    // El renglón se pasa porque numero_pedido/fecha son del modal de edición y aquí llegan vacíos
                    detalle: `Pedido ${ped?.numero ?? numero_pedido} ${ped?.fecha ?? fecha} ${ped?.clientes ?? ""}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                );
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Se quito la autorizacion",
                  showConfirmButton: false,
                  timer: 2000,
                });
                const newComments = comments.map((i) => {
                  if (id === i._id) {
                    i.autorizadoSurtido = "No";
                    i.autorizadoApartado = "No";
                  }
                  return i;
                });
                setComments(newComments);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  async function autorizarSurtido(id, ped) {
    const URL_AUTORIZADO = `${URL_PEDIDOS}/${id}`;
    const URL_AUTORIZADO_HIJO = `${URL_ARTICULOS_PEDIDO}/autorizadoSurtido/${id}`;
    // Antes de autorizar se revisa si hay disponible de cada artículo (la
    // misma regla de Disponible: existencia − lo autorizado de otros pedidos).
    // Sólo avisa: la decisión de autorizar es del usuario.
    let faltan = [];
    try {
      const r = await axios.get(`${URL_PEDIDOS}RevisaDisponible/${id}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      });
      faltan = r.data?.faltan || [];
    } catch (err) {
      console.log("No se pudo revisar el disponible:", err);
    }
    const num = (n) => new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(Number(n) || 0);
    Swal.fire({
      title: faltan.length ? "No alcanza el inventario" : "Estas seguro?",
      icon: "warning",
      ...(faltan.length
        ? {
            html:
              `Estos artículos no tienen disponible suficiente:<br/><br/>` +
              `<table style="width:100%;font-size:14px;border-collapse:collapse">` +
              `<tr><th style="text-align:left">Artículo</th><th style="text-align:right">Pide</th><th style="text-align:right">Disponible</th><th style="text-align:right">Falta</th></tr>` +
              faltan
                .map(
                  (f) =>
                    `<tr><td style="text-align:left">${f.codigo} ${f.nombre || ""}</td>` +
                    `<td style="text-align:right">${num(f.necesita)}</td>` +
                    `<td style="text-align:right">${num(f.disponible)}</td>` +
                    `<td style="text-align:right;color:#dc3545;font-weight:bold">${num(f.falta)}</td></tr>`
                )
                .join("") +
              `</table><br/>¿Autorizar el surtido de todos modos?`,
            width: 700,
          }
        : { text: "Se va a autorizar Surtir!" }),
      showCancelButton: true,
      confirmButtonColor: faltan.length ? "#dc3545" : "#3085d6",
      cancelButtonColor: faltan.length ? "#6c757d" : "#d33",
      confirmButtonText: faltan.length ? "Autorizar de todos modos" : "Si, autorizar!",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            URL_AUTORIZADO,
            {
              autorizadoSurtido: "Si",
              autorizadoApartado: "Si",
              autorizoSurtido: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .patch(
                URL_AUTORIZADO_HIJO,
                {
                  autorizadoSurtido: "Si",
                  autorizadoApartado: "Si",
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                axios.post(
                  URL_LOGS,
                  {
                    tipo: "Autorizar Surtido",
                    detalle: `Pedido ${ped?.numero ?? numero_pedido} ${ped?.fecha ?? fecha} ${ped?.clientes ?? ""}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                );
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Se Autorizo",
                  showConfirmButton: false,
                  timer: 2000,
                });
                const newComments = comments.map((i) => {
                  if (id === i._id) {
                    i.autorizadoSurtido = "Si";
                    i.autorizadoApartado = "Si";
                  }
                  return i;
                });
                setComments(newComments);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

        function desarrollo(){
      axios
        .get(
          `${URL_PEDIDOS}Desarrollo`,
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )      
        .then(() => {
          Swal.fire("Good job!", "Enviado con exito", "success");
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_pedidos ? (
        <div className="card col-12">
          {!AbrirEditar ? (
            <>
              <Row>
                <Col md={8}>
                  {user.pedidos_create ? (
                    <Button
                      size="sm"
                      type="submit"
                      className="btn btn-success"
                      href="/PedidosCreate"
                    >
                      Nueva Cotizacion
                    </Button>
                  ) : (
                    <Button
                      size="sm"
                      type="submit"
                      className="btn btn-success"
                      disabled
                    >
                      Nueva Cotizacion
                    </Button>
                  )}
                  {/* {user.pedidos_create ? (
                    <Button
                      size="sm"
                      type="submit"
                      className="btn btn-info"
                      href="/PedidosCreateMarket"
                      style={{ marginLeft: 6 }}
                    >
                      <i className="fas fa-store"></i> Pedido Market
                    </Button>
                  ) : (
                    <Button
                      size="sm"
                      type="submit"
                      className="btn btn-info"
                      disabled
                      style={{ marginLeft: 6 }}
                    >
                      <i className="fas fa-store"></i> Pedido Market
                    </Button>
                  )} */}
                  <Button
                    size="sm"
                    href="/MenuVentas"
                    className="btn btn-danger"
                    id="botonListado"
                  >
                    Regresar
                  </Button>
                </Col>
                <Col sm={4}>
                  <ButtonGroup id="logoutBoton">
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      // onClick={desarrollo}
                      onClick={PDFTabla}
                    >
                      PDF <i class="far fa-file-pdf"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      onClick={toggleMail}
                      color="info"
                    >
                      eMail <i class="fas fa-at"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="primary"
                      onClick={excel}
                    >
                      Excel <i class="far fa-file-excel"></i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
              <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
                <ModalHeader toggle={toggleMail}>
                  <h4>Enviar Listado Cotizaciones</h4>
                </ModalHeader>
                <ModalBody>
                  <Label className="mr-sm-2">Email</Label>
                  <Input
                    className="col-sm-12"
                    type="text"
                    value={mailTo}
                    required
                    onChange={(e) => {
                      setMailTo(e.target.value);
                    }}
                  />
                </ModalBody>
                <ModalFooter>
                  <Button size="sm" color="success" onClick={enviaMail}>
                    Enviar
                  </Button>
                </ModalFooter>
              </Modal>
              <h3 align="center">Cotizaciones</h3>
              <div className="row">
                <div className="col-md-8">
                  <Pagination
                    total={totalItems}
                    itemsPerPage={ITEMS_PER_PAGE}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                  />
                </div>
                <div className="col-md-4 d-flex flex-row-reverse">
                  <Search
                    onSearch={(value) => {
                      setSearch(value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>
              <Row>
                <Col md={2}>
                  <Label className="mr-sm-2">Fecha Inicio</Label>
                  <Input
                    bsSize="sm"
                    type="date"
                    value={selectedFechaInicio}
                    required
                    onChange={(e) => {
                      setSelectedFechaInicio(e.target.value);
                    }}
                  />
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Fecha Fin</Label>
                  <Input
                    bsSize="sm"
                    type="date"
                    value={selectedFechaFin}
                    required
                    onChange={(e) => {
                      setSelectedFechaFin(e.target.value);
                    }}
                  />
                </Col>

                {/* <Col md={2}>
                  <Label>Autorizado</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={autorizadoApartado}
                    required
                    onChange={(e) => {
                      setAutorizadoApartado(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">Selecciona</option>
                    <option value="Si">Si</option>
                    <option value="No">No</option>
                  </Input>
                </Col> */}

                <Col md={2}>
                  <Label>Autorizado Surtir</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={autorizadoSurtido}
                    required
                    onChange={(e) => {
                      setAutorizadoSurtido(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">Selecciona</option>
                    <option value="Si">Si</option>
                    <option value="No">No</option>
                  </Input>
                </Col>

                <Col md={2}>
                  <Label>Status</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={status}
                    required
                    onChange={(e) => {
                      setStatus(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">Todos</option>
                    <option value="Abierto">Abierto</option>
                    <option value="Cerrado">Cerrado</option>
                    <option value="Cancelado">Cancelado</option>
                  </Input>
                </Col>
              </Row>
              <br />
              <Table
                size="sm"
                striped
                borderless
                className="table-responsive-xl"
              >
                <TableHeader
                  headers={headers}
                  onSorting={(field, order) => setSorting({ field, order })}
                />
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td style={{ paddingTop: "0px" }}>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={selectedCliente}
                      onChange={(e) => {
                        setSelectedCliente(e.target.value);
                        setCurrentPage(1);
                      }}
                    >
                      <option value="0">Selecciona</option>
                      {clientes
                        .sort((a, b) =>
                          a.nombre_comercial > b.nombre_comercial ? 1 : -1
                        )
                        .map((a) => {
                          return (
                            <option value={a._id}>{a.nombre_comercial}</option>
                          );
                        })}
                    </Input>
                  </td>
                  <td style={{ paddingTop: "0px" }}>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={selectedColaborador}
                      onChange={(e) => {
                        setSelectedColaborador(e.target.value);
                        setCurrentPage(1);
                      }}
                    >
                      <option value="">Selecciona un Vendedor</option>
                      {colaboradores
                        .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                        .map((a) => {
                          return (
                            <option value={a._id}>
                              {a.nombre} {a.apellido}
                            </option>
                          );
                        })}
                    </Input>
                  </td>
                </tr>
                <tbody>
                  {commentsData.map((a) => {
                    if (a.activo == "No") {
                      return (
                        // key por pedido: sin ella React reutiliza el renglón
                        // entre pedidos distintos y los UncontrolledTooltip
                        // buscan un id que aún no existe en el DOM.
                        <tr key={a._id} style={{ backgroundColor: "#ed8c8c" }}>
                          {/* <td>{a.activo}</td> */}
                          <td>{a.numero}</td>
                          <td>{fDMA(a.fecha)}</td>
                          <td>{fDMA(a.fechaInicio)}</td>
                          <td>{fDMA(a.fechaCancelacion)}</td>
                          <td>{a.clientes}</td>
                          <td>{a.colaboradores}</td>
                          <td></td>
                          <td align="right"></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>CANCELADO</td>
                          <td></td>
                          <td></td>
                        </tr>
                      );
                    } else {
                      return (
                        <tr key={a._id}>
                          {/* <td>{a.activo}</td> */}
                          <td>{a.numero}</td>
                          <td>{fDMA(a.fecha)}</td>
                          <td>{fDMA(a.fechaInicio)}</td>
                          <td>{fDMA(a.fechaCancelacion)}</td>
                          <td>{a.clientes}</td>
                          <td>{a.colaboradores}</td>
                          <td>
                            {new Intl.NumberFormat("en-US").format(
                              a.total_cantidad
                            )}
                          </td>
                          <td>
                            {new Intl.NumberFormat("en-US").format(
                              a.piezasEntregadas
                            )}
                          </td>
                          <td>
                            {new Intl.NumberFormat("en-US").format(
                              a.piezasPendientes
                            )}
                          </td>
                          <td>
                            <span style={{ color: a.autorizadoSurtido === "Si" ? "#28a745" : "#dc3545", fontWeight: "bold" }}>
                              {a.autorizadoSurtido}
                            </span>
                          </td>
                          <td align="right">
                            {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.subTotal || 0)}
                          </td>
                          <td align="right">
                            {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.iva || 0)}
                          </td>
                          <td align="right">
                            {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.total_general || 0)}
                          </td>
                          {/* Autorización: surtido, status, baja */}
                          <td>
                            {user.pedidos_create ? (
                              <div>
                                {a.surtido == "No" &&
                                user.pedidos_autorizar &&
                                a.status == "Abierto" ? (
                                  a.autorizadoSurtido == "Si" ? (
                                    <span>
                                      <Button
                                        color="primary"
                                        id={`desautSurt-${a._id}`}
                                        onClick={(e) =>
                                          desautorizarSurtido(a._id, a)
                                        }
                                        size="sm"
                                      >
                                        <i class="fas fa-truck"></i>
                                      </Button>
                                      <UncontrolledTooltip placement="top" target={`desautSurt-${a._id}`}>Desautorizar surtido</UncontrolledTooltip>
                                    </span>
                                  ) : (
                                    <span>
                                      <Button
                                        color="danger"
                                        id={`autSurt-${a._id}`}
                                        onClick={(e) => autorizarSurtido(a._id, a)}
                                        size="sm"
                                      >
                                        <i class="fas fa-truck"></i>
                                      </Button>
                                      <UncontrolledTooltip placement="top" target={`autSurt-${a._id}`}>Autorizar surtido</UncontrolledTooltip>
                                    </span>
                                  )
                                ) : undefined}

                                {(a.surtido == "No" || a.status == "Cerrado") &&
                                user.pedidos_autorizar ? (
                                  <StatusMultiple
                                    idStatus={a._id}
                                    status={a.status}
                                    URL_STATUS={URL_PEDIDOS}
                                    hijo={`${URL_ARTICULOS_PEDIDO}/baja`}
                                    onStatusChange={(
                                      id,
                                      nuevoStatus,
                                    ) => {
                                      setComments((prev) =>
                                        prev.map((item) =>
                                          item._id === id
                                            ? {
                                                ...item,
                                                status: nuevoStatus,
                                              }
                                            : item
                                        )
                                      );
                                    }}
                                  />
                                ) : undefined}

                                {a.surtido == "No" && user.pedidos_autorizar ? (
                                  <BajaMultiple
                                    idStatus={a._id}
                                    is_active={a.activo}
                                    URL_BAJA={URL_PEDIDOS}
                                    hijo={`${URL_ARTICULOS_PEDIDO}/baja`}
                                    onStatusChange={(id, nuevoEstado) => {
                                      setComments((prev) =>
                                        prev.map((item) =>
                                          item._id === id
                                            ? { ...item, activo: nuevoEstado }
                                            : item
                                        )
                                      );
                                    }}
                                  />
                                ) : undefined}
                              </div>
                            ) : undefined}
                          </td>
                          {/* Edición / PDF: ver, PDF, peso, Excel, duplicar, editar */}
                          <td>
                            {/* Ver pedido en modo consulta (sin editar).
                                Disponible para cualquier status del pedido. */}
                            <Button
                              size="sm"
                              className="btn"
                              color="secondary"
                              id={`ver-${a._id}`}
                              onClick={() => verPedidoDetalle(a)}
                            >
                              <i className="fas fa-eye"></i>
                            </Button>
                            <UncontrolledTooltip placement="top" target={`ver-${a._id}`}>
                              Visualizar pedido
                            </UncontrolledTooltip>
                            {user.pedidos_create ? (
                              <div>
                                {a.status == "Abierto" ? (
                                  <>
                                    <Button
                                      size="sm"
                                      className="btn"
                                      color="danger"
                                      id={`pdf-${a._id}`}
                                      onClick={(e) => {
                                        Swal.fire({
                                          title: "PDF del pedido",
                                          text: "¿Cómo deseas el PDF?",
                                          icon: "question",
                                          input: "radio",
                                          inputOptions: {
                                            con: "Con imágenes",
                                            sin: "Sin imágenes",
                                            barras: "Con códigos de barras (EAN13)",
                                          },
                                          inputValue: "con",
                                          showCancelButton: true,
                                          confirmButtonText: "Generar",
                                          cancelButtonText: "Cancelar",
                                          confirmButtonColor: "#911c04",
                                          inputValidator: (value) => {
                                            if (!value) return "Selecciona una opción";
                                          },
                                        }).then((result) => {
                                          if (!result.value) return;
                                          if (result.value === "barras") {
                                            PDFBarrasOC(a._id, a.numero, a.clientes);
                                            return;
                                          }
                                          const conImagenes = result.value === "con";
                                          PDFOC(
                                            a.fecha,
                                            a.colaboradores,
                                            a.idClientes,
                                            a.clientes,
                                            a.total_cantidad,
                                            a.total_general,
                                            a.observaciones,
                                            a.numero,
                                            a.impuestos,
                                            a.descuento,
                                            a.comisionFlete,
                                            a.comisionTDC,
                                            a._id,
                                            a.calle,
                                            a.numero_ext,
                                            a.numero_int,
                                            a.pais,
                                            a.estado,
                                            a.ciudad,
                                            a.delegacion,
                                            a.colonia,
                                            a.cp,
                                            a.RFC,
                                            a.paqueteria,
                                            a.codigoClientes,
                                            a.autorizadoApartado,
                                            a.autorizadoSurtido,
                                            a.telefono,
                                            a.editado,
                                            a.editPedido,
                                            a.autorizoApartado,
                                            a.autorizoSurtido,
                                            a.subTotal,
                                            a.iva,
                                            conImagenes
                                          );
                                        });
                                      }}
                                    >
                                      <i class="far fa-file-pdf"></i>
                                    </Button>
                                    <UncontrolledTooltip placement="top" target={`pdf-${a._id}`}>Imprimir PDF</UncontrolledTooltip>
                                    {/* C9: PDF Peso */}
                                    <Button
                                      size="sm"
                                      className="btn"
                                      color="warning"
                                      id={`peso-${a._id}`}
                                      onClick={() => PDFPeso(a._id, a.numero, a.clientes, a.fecha)}
                                    >
                                      <i class="fas fa-weight-hanging"></i>
                                    </Button>
                                    <UncontrolledTooltip placement="top" target={`peso-${a._id}`}>PDF Peso</UncontrolledTooltip>
                                    <Button
                                      size="sm"
                                      className="btn"
                                      color="primary"
                                      id={`xls-${a._id}`}
                                      onClick={(e) => excelOC(a._id, a.numero)}
                                    >
                                      <i class="far fa-file-excel"></i>
                                    </Button>
                                    <UncontrolledTooltip placement="top" target={`xls-${a._id}`}>Descargar Excel</UncontrolledTooltip>
                                  </>
                                ) : undefined}
                              </div>
                            ) : undefined}
                            {a.surtido == "No" ? (
                              a.status == "Abierto" && a.activo == "Si" ? (
                                <div>
                                  <>
                                  <Button
                                    color="success"
                                    size="sm"
                                    id={`dup-${a._id}`}
                                    onClick={() => duplicarPedido(a._id)}
                                  >
                                    <i className="far fa-copy"></i>
                                  </Button>
                                  <UncontrolledTooltip placement="top" target={`dup-${a._id}`}>Duplicar pedido</UncontrolledTooltip>
                                  </>
                                  <>
                                  <Button
                                    color="info"
                                    id={`edit-${a._id}`}
                                    size="sm"
                                    onClick={(e) => {
                                      setCurrentEditPedidoRow(a);
                                      setFechaProgramadaEdit(a.fecha_programada || "");
                                      jalaInfo(
                                        a.fecha,
                                        a.idColaboradores,
                                        a.idClientes,
                                        a.total_cantidad,
                                        a.total_general,
                                        a.observaciones,
                                        a.numero,
                                        a.comisionTDC,
                                        a.comisionFlete,
                                        a.impuestos,
                                        a.paqueteria,
                                        a._id
                                      );
                                    }}
                                  >
                                    <i class="far fa-edit"></i>
                                  </Button>
                                  <UncontrolledTooltip placement="top" target={`edit-${a._id}`}>Editar pedido</UncontrolledTooltip>
                                  </>
                                </div>
                              ) : undefined
                            ) : undefined}
                          </td>
                        </tr>
                      );
                    }
                  })}
                  {/* Totales del listado filtrado (excluye canceladas) */}
                  <tr style={{ borderTop: "2px solid #333", fontWeight: "bold" }}>
                    <td colSpan={6} align="right">
                      TOTALES ({vivas.length} cotizaciones)
                    </td>
                    <td>{new Intl.NumberFormat("en-US").format(totPiezas)}</td>
                    <td>{new Intl.NumberFormat("en-US").format(totSurtidas)}</td>
                    <td>{new Intl.NumberFormat("en-US").format(totPendientes)}</td>
                    <td></td>
                    <td align="right">
                      {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(totSubTotal)}
                    </td>
                    <td align="right">
                      {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(totIva)}
                    </td>
                    <td align="right">
                      {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(totGeneral)}
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </Table>
              <div className="col-md-6">
                <Pagination
                  total={totalItems}
                  itemsPerPage={ITEMS_PER_PAGE}
                  currentPage={currentPage}
                  onPageChange={(page) => setCurrentPage(page)}
                />
              </div>
            </>
          ) : (
            <div className="card container col-md-12">
              <h4>Editar Pedido {numero_pedido}</h4>
              <h4>Cliente: {nombreClienteEdit}</h4>
              <Form onSubmit={savePedido}>
                <Row>
                  {/* <Col md={1}>
                    <Label>TDC</Label>
                    <CurrencyInput
                      intlConfig={{ locale: "en-US", currency: "USD" }}
                      prefix="$"
                      placeholder="Ingresa una cantidad"
                      defaultValue={0}
                      decimalsLimit={2}
                      value={comisionTDC}
                      className={`form-control`}
                      onValueChange={(value) => {
                        jalaComisionTDC(value);
                      }}
                    />
                  </Col>
                  <Col md={1}>
                    <Label>Flete</Label>
                    <CurrencyInput
                      intlConfig={{ locale: "en-US", currency: "USD" }}
                      prefix="$"
                      placeholder="Ingresa una cantidad"
                      defaultValue={0}
                      decimalsLimit={2}
                      value={comisionFlete}
                      className={`form-control`}
                      onValueChange={(value) => {
                        jalaComisionFlete(value);
                      }}
                    />
                  </Col> */}
                  <Col md={1}>
                    <Label>Impuestos %</Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      value={selectedImpuesto}
                      onChange={(e) => {
                        calculaImpuesto(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Lista de Precios</Label>
                    <Input
                      type="select"
                      value={listaPreciosEdit}
                      onChange={(e) => {
                        const nuevaLista = Number(e.target.value);
                        setListaPreciosEdit(nuevaLista);
                        const nuevoPrecio = (art) => {
                          if (!art) return 0;
                          if (nuevaLista === 1) return Number(art.lista1 ?? art.venta ?? 0);
                          if (nuevaLista === 2) return Number(art.lista2 ?? art.venta ?? 0);
                          if (nuevaLista === 3) return Number(art.lista3 ?? art.venta ?? 0);
                          if (nuevaLista === 4) return Number(art.lista4 ?? art.venta ?? 0);
                          if (nuevaLista === 5) return Number(art.lista5 ?? art.venta ?? 0);
                          return Number(art.venta ?? 0);
                        };
                        const conDesc = (i, precio) => {
                          const cant = parseFloat(i.cantidad) || 0;
                          const desc = parseFloat(i.descuento) || 0;
                          return cant * precio * (1 - desc / 100);
                        };
                        const newAP = articulosPedido.map((i) => {
                          const art = articulos.find((a) => a._id === i.articulos);
                          if (!art) return i;
                          const precio = nuevoPrecio(art);
                          return { ...i, precio, total: conDesc(i, precio) };
                        });
                        setArticulosPedido(newAP);
                        const newIF = inputFields.map((i) => {
                          const art = articulos.find((a) => a._id === i.articulos);
                          if (!art) return i;
                          const precio = nuevoPrecio(art);
                          return { ...i, precio, total: conDesc(i, precio) };
                        });
                        setInputFields(newIF);
                        // Recalcular totales SÍNCRONAMENTE con los nuevos arrays
                        const activos2 = newAP.filter((e) => e.is_active == "Si").concat(newIF);
                        const TA = activos2.reduce((t, c) => t + (parseFloat(c.cantidad) || 0), 0);
                        const TG = activos2.reduce((t, c) => t + (parseFloat(c.total) || 0), 0);
                        const DESC = descuento != 0 ? (TG * descuento) / 100 : 0;
                        const ivaTT = selectedImpuesto != 0 ? (selectedImpuesto * (TG - DESC)) / 100 : 0;
                        setTotalCantidadEdit(TA);
                        setSubTotal(TG.toFixed(2));
                        setIva(ivaTT);
                        setTotalGeneralEdit(TG + ivaTT + (parseFloat(comisionFlete) || 0) + (parseFloat(comisionTDC) || 0) - DESC);
                      }}
                    >
                      <option value="1">Lista 1 (base)</option>
                      <option value="2">Lista 2 (-30%)</option>
                      <option value="3">Lista 3 (-25%)</option>
                      <option value="4">Lista 4 (-20%)</option>
                      <option value="5">Lista 5 (-15%)</option>
                    </Input>
                  </Col>
                  <Col md={1}>
                                <Label>Descuento %</Label>
                                <Input
                                  type="number"
                                  min="0"
                                  step="any"
                                  value={descuento}
                                  onChange={(e) => {
                                    calculaDescuento(e.target.value);
                                  }}
                                />
                              </Col>
 <Col md={1}>
              <Label>Descuento $</Label>
              <Input
                type="number"
                min="0"
                step="any"
                value={descuentoNumero}
                disabled
              />
            </Col>
                  <Col md={2}>
                    <Label>Sub Total</Label>
                    <CurrencyInput
                      intlConfig={{ locale: "en-US", currency: "USD" }}
                      prefix="$"
                      placeholder="Ingresa una cantidad"
                      defaultValue={0}
                      decimalsLimit={2}
                      value={subTotal}
                      disabled
                      className={`form-control`}
                    />
                  </Col>

                  <Col md={2}>
                    <Label>IVA</Label>
                    <CurrencyInput
                      intlConfig={{ locale: "en-US", currency: "USD" }}
                      prefix="$"
                      placeholder="Ingresa una cantidad"
                      defaultValue={0}
                      decimalsLimit={2}
                      value={Number(iva || 0).toFixed(2)}
                      disabled
                      className={`form-control`}
                    />
                  </Col>

                  <Col md={2}>
                    <Label>Total</Label>
                    <CurrencyInput
                      intlConfig={{ locale: "en-US", currency: "USD" }}
                      prefix="$"
                      placeholder="Ingresa una cantidad"
                      defaultValue={0}
                      decimalsLimit={2}
                      value={Number(total_general_edit || 0).toFixed(2)}
                      disabled
                      className={`form-control`}
                    />
                  </Col>

                  <Col md={1}>
                    <Label>Piezas</Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Piezas"
                      value={total_cantidad_edit}
                      required
                      disabled
                    />
                  </Col>

                 {/* <Col md={1}>
                    <Label></Label>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={(e) => toggleCambiaPrecio()}
                    >
                      Cambiar Precio <i class="fas fa-dollar-sign"></i>
                    </Button>
                  </Col> */}
                </Row>
                <br />
                <Row>
                  <Col md={2}>
                    <Label className="mr-sm-2">Articulos</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Disponible</Label>
                  </Col>
                  {/* <Col md={1}>
                    <Label className="mr-sm-2">Por Recibir</Label>
                  </Col> */}
                  <Col md={1}>
                    <Label className="mr-sm-2">Cajas</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Pzas Caja</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Cantidad</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Surtido</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Precio</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Desc %</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Total</Label>
                  </Col>
                </Row>

                {articulosPedido.map((ao) => (
                  <div key={ao.id}>
                    <Row>
                      {ao.surtido == 0 ? (
                        <Col md={2}>
                          <Input
                            name="articulos"
                            type="select"
                            value={ao.articulos}
                            required
                            onChange={(event) => {
                              BuscaArticuloExistentes(ao.id, event);
                            }}
                          >
                            <option value="">Selecciona</option>
                            {articulos
                              .sort((a, b) => (a.codigo > b.codigo ? 1 : -1))
                              .map((a) => {
                                return (
                                  <option value={a._id}>
                                    {a.codigo} {a.nombre}
                                  </option>
                                );
                              })}
                          </Input>
                        </Col>
                      ) : (
                        <Col md={2}>
                          <Input
                            name="articulos"
                            type="select"
                            value={ao.articulos}
                            required
                            disabled
                          >
                            <option value="">Selecciona</option>
                            {articulos
                              .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                              .map((a) => {
                                return (
                                  <option value={a._id}>{a.nombre}</option>
                                );
                              })}
                          </Input>
                        </Col>
                      )}

                      <Col md={1}>
                        <Input type="select" disabled>
                          {inventarios.map((a) => {
                            if (ao.articulos == a.idArticulo) {
                              return (
                                <option value={a._id}>{a.disponible}</option>
                              );
                            }
                          })}
                        </Input>
                      </Col>

                      {/* <Col md={1}>
                        <Input
                          type="text"
                          disabled
                          value={(() => {
                            const inv = inventarios.find(
                              (a) => a.idArticulo === ao.articulos
                            );
                            return inv ? Number(inv.porRecibir || 0) : 0;
                          })()}
                        />
                      </Col> */}

                      <Col md={1}>
                        <Input
                          //  bsSize="sm"
                          name="cajas"
                          type="string"
                          value={ao.cajas}
                          onChange={(event) =>
                            handleChangeInputCajasExistentes(ao.id, event)
                          }
                        ></Input>
                      </Col>

                      <Col md={1}>
                        <Input
                          //  bsSize="sm"
                          name="piezasPorCaja"
                          type="string"
                          value={ao.piezasPorCaja}
                          disabled
                        ></Input>
                      </Col>

                      <Col md={1}>
                        <Input
                          // bsSize="sm"
                          name="cantidad"
                          type="number"
                          min="0"
                          step="any"
                          placeholder="Cantidad"
                          value={ao.cantidad}
                          required
                          onChange={(event) =>
                            handleChangeInputCantidadExistentes(ao.id, event)
                          }
                        />
                      </Col>

                      <Col md={1}>
                        <Input
                          // bsSize="sm"
                          name="surtido"
                          type="number"
                          min="0"
                          step="any"
                          placeholder="surtido"
                          value={ao.surtido}
                          disabled
                        />
                      </Col>

                      {user.cambiaPrecios && ao.surtido == 0 ? (
                        <Col md={1}>
                          <CurrencyInput
                            intlConfig={{ locale: "en-US", currency: "USD" }}
                            prefix="$"
                            name="precio"
                            defaultValue={0}
                            decimalsLimit={2}
                            value={ao.precio}
                            className={`form-control`}
                            onValueChange={(value) =>
                              handleChangeInputExistentesPrecio(ao.id, value)
                            }
                          />
                        </Col>
                      ) : cambiarPrecio ? (
                        <Col md={1}>
                          <CurrencyInput
                            intlConfig={{ locale: "en-US", currency: "USD" }}
                            prefix="$"
                            name="precio"
                            defaultValue={0}
                            decimalsLimit={2}
                            value={ao.precio}
                            className={`form-control`}
                            onValueChange={(value) =>
                              handleChangeInputExistentesPrecio(ao.id, value)
                            }
                          />
                        </Col>
                      ) : (
                        <Col md={1}>
                          <CurrencyInput
                            intlConfig={{ locale: "en-US", currency: "USD" }}
                            prefix="$"
                            name="precio"
                            defaultValue={0}
                            decimalsLimit={2}
                            value={ao.precio}
                            className={`form-control`}
                            disabled
                          />
                        </Col>
                      )}

                      <Col md={1}>
                        <Input
                          type="number"
                          min="0"
                          max="100"
                          step="any"
                          name="descuento"
                          placeholder="Desc %"
                          value={ao.descuento || 0}
                          onChange={(event) => {
                            const nuevoDesc = event.target.value;
                            const newAP = articulosPedido.map((i) => {
                              if (i.id === ao.id) {
                                const cant = parseFloat(i.cantidad) || 0;
                                const precio = parseFloat(i.precio) || 0;
                                const desc = parseFloat(nuevoDesc) || 0;
                                return { ...i, descuento: nuevoDesc, total: cant * precio * (1 - desc / 100) };
                              }
                              return i;
                            });
                            setArticulosPedido(newAP);
                            ActualizaTotales(newAP, inputFields);
                          }}
                        />
                      </Col>
                      <Col md={1}>
                        <CurrencyInput
                          intlConfig={{ locale: "en-US", currency: "USD" }}
                          prefix="$"
                          name="total"
                          defaultValue={0}
                          decimalsLimit={2}
                          value={ao.total}
                          className={`form-control`}
                          disabled
                        />
                      </Col>
                      <Col md={1}>
                        {ao.is_active == "Si" ? (
                          <Button
                            color="primary"
                            id="Baja"
                            onClick={(e) => {
                              bajaArticulo(ao.id);
                            }}
                            size="sm"
                          >
                            <i class="far fa-check-circle"></i>
                          </Button>
                        ) : (
                          <Button
                            color="danger"
                            onClick={(e) => {
                              altaArticulo(ao.id);
                            }}
                            size="sm"
                          >
                            <i class="far fa-times-circle"></i>
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </div>
                ))}

                {/* V4: switch entre vista normal y marketplace */}
                <Row>
                  <Col md={3}>
                    <Button
                      size="sm"
                      color={vistaMarketEdit ? "secondary" : "primary"}
                      onClick={() => setVistaMarketEdit(!vistaMarketEdit)}
                    >
                      <i className={`fas ${vistaMarketEdit ? "fa-list" : "fa-th-large"}`}></i>{" "}
                      {vistaMarketEdit ? "Vista Lista" : "Vista Market"}
                    </Button>
                  </Col>
                </Row>
                <br />

                {/* V4: vista marketplace (cards) — catálogo completo con filtros y fotos cloudinary */}
                {vistaMarketEdit && (() => {
                  const fotoUrlMkt = (art) =>
                    art.foto === "Si"
                      ? `${URL_FOTO_CLOUDINARY}/image/upload/macuroArticulos/${art._id}.jpg`
                      : SIN_IMAGEN_MKT;
                  const setMarketCantidad = (art, valor) => {
                    const cant = parseFloat(valor) || 0;
                    const yaEnPedido = articulosPedido.find((p) => p.articulos === art._id);
                    if (yaEnPedido) {
                      const newAP = articulosPedido.map((i) =>
                        i.articulos === art._id
                          ? {
                              ...i,
                              cantidad: cant,
                              total: cant * parseFloat(i.precio || 0),
                              pendiente_surtir: cant - (parseFloat(i.surtido) || 0),
                              cajas: i.piezasPorCaja > 0 ? cant / i.piezasPorCaja : 0,
                            }
                          : i
                      );
                      setArticulosPedido(newAP);
                      ActualizaTotales(newAP, inputFields);
                      return;
                    }
                    const existeIF = inputFields.find((i) => i.articulos === art._id);
                    if (cant <= 0) {
                      if (existeIF) {
                        const filtered = inputFields.filter((i) => i.articulos !== art._id);
                        setInputFields(filtered);
                        ActualizaTotales(articulosPedido, filtered);
                      }
                      return;
                    }
                    const precio = parseFloat(art.lista1 ?? art.venta ?? 0);
                    let newIFFinal;
                    if (existeIF) {
                      newIFFinal = inputFields.map((i) =>
                        i.articulos === art._id
                          ? {
                              ...i,
                              cantidad: cant,
                              total: cant * precio,
                              cajas: art.piezasPorCaja > 0 ? cant / art.piezasPorCaja : 0,
                            }
                          : i
                      );
                      setInputFields(newIFFinal);
                    } else {
                      newIFFinal = [
                        ...inputFields.filter((i) => i.articulos),
                        {
                          id: uuidv4(),
                          articulos: art._id,
                          articulosNombre: art.codigo + " " + art.nombre,
                          piezasPorCaja: parseFloat(art.piezasPorCaja || 0),
                          cajas: art.piezasPorCaja > 0 ? cant / art.piezasPorCaja : 0,
                          cantidad: cant,
                          precio,
                          total: cant * precio,
                          fotoArticulo: fotoUrlMkt(art),
                        },
                      ];
                      setInputFields(newIFFinal);
                    }
                    ActualizaTotales(articulosPedido, newIFFinal);
                  };
                  const cantidadEnPedido = (artId) => {
                    const enAP = articulosPedido.find((p) => p.articulos === artId);
                    if (enAP) return enAP.cantidad;
                    const enIF = inputFields.find((i) => i.articulos === artId);
                    return enIF ? enIF.cantidad : 0;
                  };
                  const tokens = (marketSearch || "").toLowerCase().trim().split(/\s+/).filter(Boolean);
                  const filtrados = (articulos || []).filter((a) => {
                    if (a.is_active === "No") return false;
                    if (marketFiltroMarca && a.marcas?.[0]?._id !== marketFiltroMarca) return false;
                    if (marketFiltroLinea && a.lineas?.[0]?._id !== marketFiltroLinea) return false;
                    if (tokens.length > 0) {
                      const hay = `${a.codigo || ""} ${a.nombre || ""} ${a.descripcion || ""} ${a.SKU || ""} ${a.marcas?.[0]?.name || ""} ${a.lineas?.[0]?.name || ""}`.toLowerCase();
                      return tokens.every((t) => hay.includes(t));
                    }
                    return true;
                  }).sort((a, b) => (a.codigo || "").localeCompare(b.codigo || ""));
                  return (
                    <>
                      <Row style={{ marginBottom: 12 }}>
                        <Col md={6}>
                          <Label>Buscar</Label>
                          <Input
                            type="text"
                            bsSize="sm"
                            placeholder="Buscar por código, nombre, SKU..."
                            value={marketSearch}
                            onChange={(e) => setMarketSearch(e.target.value)}
                          />
                        </Col>
                        <Col md={3}>
                          <Label>Marca</Label>
                          <Input
                            type="select"
                            bsSize="sm"
                            value={marketFiltroMarca}
                            onChange={(e) => setMarketFiltroMarca(e.target.value)}
                          >
                            <option value="">Todas</option>
                            {marcasEditMarket
                              .filter((m) => !m.is_active || m.is_active === "Si")
                              .sort((a, b) => (a.name > b.name ? 1 : -1))
                              .map((m) => (
                                <option key={m._id} value={m._id}>{m.name}</option>
                              ))}
                          </Input>
                        </Col>
                        <Col md={3}>
                          <Label>Categoría</Label>
                          <Input
                            type="select"
                            bsSize="sm"
                            value={marketFiltroLinea}
                            onChange={(e) => setMarketFiltroLinea(e.target.value)}
                          >
                            <option value="">Todas</option>
                            {lineasEditMarket
                              .filter((l) => !l.is_active || l.is_active === "Si")
                              .sort((a, b) => (a.name > b.name ? 1 : -1))
                              .map((l) => (
                                <option key={l._id} value={l._id}>{l.name}</option>
                              ))}
                          </Input>
                        </Col>
                      </Row>
                      <div style={{ fontSize: 12, color: "#666", marginBottom: 8 }}>
                        Mostrando <b>{filtrados.length}</b> productos
                      </div>
                      <Row>
                        {filtrados.map((art) => {
                          const cant = cantidadEnPedido(art._id);
                          // Precio según la lista elegida en el pedido, con la
                          // misma cascada que PedidosCreateMarket. Antes usaba
                          // `lista1 ?? venta`: con lista1 en 0 se quedaba en 0.
                          const nLista = Number(listaPreciosEdit);
                          const precio =
                            nLista === 2 && art.lista2 ? Number(art.lista2)
                            : nLista === 3 && art.lista3 ? Number(art.lista3)
                            : nLista === 4 && art.lista4 ? Number(art.lista4)
                            : art.lista1 ? Number(art.lista1)
                            : Number(art.venta || 0);
                          const disp = Number(
                            (inventarios || []).find((i) => String(i.idArticulo) === String(art._id))?.disponible || 0
                          );
                          const pr = pendRecibirMkt[art._id] || {};
                          const porRecibir = Number(pr.pendiente_recibir || 0);
                          const llegada = pr.proximaLlegada || "";
                          return (
                            <Col md={3} sm={6} xs={12} key={art._id} style={{ marginBottom: 16 }}>
                              <div style={{ border: cant > 0 ? "2px solid #28a745" : "1px solid #ddd", borderRadius: 6, padding: 10, height: "100%", backgroundColor: "#fff" }}>
                                <div style={{ backgroundColor: "#f4f4f4", height: 180, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 8 }}>
                                  <img
                                    src={fotoUrlMkt(art)}
                                    alt={art.nombre}
                                    onError={(e) => { e.target.onerror = null; e.target.src = SIN_IMAGEN_MKT; }}
                                    style={{ maxWidth: "100%", maxHeight: 180, objectFit: "contain" }}
                                  />
                                </div>
                                <div style={{ fontWeight: "bold", fontSize: 13, minHeight: 36, marginBottom: 4 }}>
                                  {art.codigo} {art.nombre}
                                </div>
                                <div style={{ fontSize: 11, color: "#999" }}>
                                  {art.marcas?.[0]?.name || ""} {art.lineas?.[0]?.name ? `· ${art.lineas[0].name}` : ""}
                                </div>
                                <div style={{ marginTop: 6 }}>
                                  <Badge color={disp > 0 ? "success" : "secondary"}>
                                    Disp: {new Intl.NumberFormat("en-US").format(disp)}
                                    {cant > 0 ? ` (-${cant})` : ""}
                                  </Badge>{" "}
                                  <Badge color="primary">
                                    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(precio)}
                                  </Badge>
                                  {art.piezasPorCaja > 0 && (
                                    <Badge color="info" style={{ marginLeft: 4 }}>
                                      x{art.piezasPorCaja}
                                    </Badge>
                                  )}
                                </div>
                                <div style={{ marginTop: 6, fontSize: 11, color: porRecibir > 0 ? "#2a7" : "#999", minHeight: 18 }}>
                                  {porRecibir > 0 ? (
                                    <>
                                      <i className="fas fa-truck"></i> Por recibir: <b>{porRecibir}</b>
                                      {llegada ? ` · llega ${fDMA(llegada)}` : ""}
                                    </>
                                  ) : (
                                    <span>Sin pendientes por recibir</span>
                                  )}
                                </div>
                                <div style={{ marginTop: 6 }}>
                                  <Input
                                    bsSize="sm"
                                    type="number"
                                    min="0"
                                    placeholder="Cantidad"
                                    value={cant || ""}
                                    onChange={(e) => setMarketCantidad(art, e.target.value)}
                                  />
                                </div>
                                {cant > 0 && (
                                  <div style={{ fontSize: 12, color: "#28a745", fontWeight: "bold", marginTop: 4, textAlign: "center" }}>
                                    <i className="fas fa-check-circle"></i> En pedido ({cant})
                                  </div>
                                )}
                              </div>
                            </Col>
                          );
                        })}
                      </Row>
                    </>
                  );
                })()}

                {/* Agregar mas articulos (vista normal) */}

                {!vistaMarketEdit && inputFields.map((inputField) => (
                  <div key={inputField.id}>
                    <Row>
                      <Col md={2}>
                        <Input
                          // bsSize="sm"
                          name="articulos"
                          type="select"
                          value={inputField.articulos}
                          required
                          onChange={(event) => {
                            BuscaArticulo(inputField.id, event);
                          }}
                        >
                          <option value="0">Selecciona</option>
                          {articulos
                            .sort((a, b) => (a.codigo > b.codigo ? 1 : -1))
                            .map((a) => {
                              return (
                                <option value={a._id}>
                                  {a.codigo} {a.nombre}
                                </option>
                              );
                            })}
                        </Input>
                      </Col>

                      <Col md={1}>
                        <Input type="select" disabled>
                          {inventarios.map((a) => {
                            if (inputField.articulos == a.idArticulo) {
                              return (
                                <option value={a._id}>{a.disponible}</option>
                              );
                            }
                          })}
                        </Input>
                      </Col>

                      <Col md={1}>
                        <Input
                          //  bsSize="sm"
                          name="cajas"
                          type="string"
                          value={inputField.cajas}
                          onChange={(event) =>
                            handleChangeInputCajas(inputField.id, event)
                          }
                        ></Input>
                      </Col>
                      <Col md={1}>
                        <Input
                          //  bsSize="sm"
                          name="piezasPorCaja"
                          type="string"
                          value={inputField.piezasPorCaja}
                          disabled
                        ></Input>
                      </Col>
                      <Col md={1}>
                        <Input
                          // bsSize="sm"
                          name="cantidad"
                          type="number"
                          min="0"
                          step="any"
                          placeholder="Cantidad"
                          value={inputField.cantidad}
                          required
                          onChange={(event) =>
                            handleChangeInputCantidad(inputField.id, event)
                          }
                        />
                      </Col>
                      <Col md={1}>
                        <Input
                          // bsSize="sm"
                          name="surtido"
                          type="number"
                          min="0"
                          step="any"
                          placeholder="0"
                          disabled
                        />
                      </Col>

                      {user.cambiaPrecios ? (
                        <Col md={1}>
                          <CurrencyInput
                            intlConfig={{ locale: "en-US", currency: "USD" }}
                            prefix="$"
                            name="precio"
                            defaultValue={0}
                            decimalsLimit={2}
                            value={inputField.precio}
                            className={`form-control`}
                            onValueChange={(value) =>
                              handleChangeInputPrecio(inputField.id, value)
                            }
                          />
                        </Col>
                      ) : cambiarPrecio ? (
                        <Col md={1}>
                          <CurrencyInput
                            intlConfig={{ locale: "en-US", currency: "USD" }}
                            prefix="$"
                            name="precio"
                            defaultValue={0}
                            decimalsLimit={2}
                            value={inputField.precio}
                            className={`form-control`}
                            onValueChange={(value) =>
                              handleChangeInputPrecio(inputField.id, value)
                            }
                          />
                        </Col>
                      ) : (
                        <Col md={1}>
                          <CurrencyInput
                            intlConfig={{ locale: "en-US", currency: "USD" }}
                            prefix="$"
                            name="precio"
                            defaultValue={0}
                            decimalsLimit={2}
                            value={inputField.precio}
                            className={`form-control`}
                            disabled
                          />
                        </Col>
                      )}

                      <Col md={1}>
                        <Input
                          type="number"
                          min="0"
                          max="100"
                          step="any"
                          name="descuento"
                          placeholder="Desc %"
                          value={inputField.descuento || 0}
                          onChange={(event) => {
                            const nuevoDesc = event.target.value;
                            const newIF = inputFields.map((i) => {
                              if (i.id === inputField.id) {
                                const cant = parseFloat(i.cantidad) || 0;
                                const precio = parseFloat(i.precio) || 0;
                                const desc = parseFloat(nuevoDesc) || 0;
                                return { ...i, descuento: nuevoDesc, total: cant * precio * (1 - desc / 100) };
                              }
                              return i;
                            });
                            setInputFields(newIF);
                            ActualizaTotales(articulosPedido, newIF);
                          }}
                        />
                      </Col>
                      <Col md={1}>
                        <CurrencyInput
                          intlConfig={{ locale: "en-US", currency: "USD" }}
                          prefix="$"
                          name="total"
                          defaultValue={0}
                          decimalsLimit={2}
                          value={inputField.total}
                          className={`form-control`}
                          disabled
                        />
                      </Col>
                      <Col>
                        <Button
                          size="sm"
                          className="btn"
                          color="danger"
                          disabled={inputFields.length === 1}
                          onClick={() => handleRemoveFields(inputField.id)}
                          tabindex="-1"
                        >
                          <i class="fas fa-minus"></i>
                        </Button>
                        <Button
                          size="sm"
                          className="btn"
                          color="info"
                          onClick={handleAddFields}
                          tabindex="-1"
                        >
                          <i class="fas fa-plus"></i>
                        </Button>
                      </Col>
                    </Row>
                  </div>
                ))}
                {validaBoton ? (
                  <Button type="submit" className="btn btn-success">
                    Guardar
                  </Button>
                ) : (
                  <Button type="submit" className="btn btn-success" disabled>
                    Guardar
                  </Button>
                )}
                <Button
                  onClick={(e) => setAbrirEditar(false)}
                  className="btn btn-danger"
                  id="botonListado"
                >
                  Regresar
                </Button>
              </Form>
            </div>
          )}
        </div>
      ) : undefined}
      <br />

      {/* Modal de SOLO LECTURA: visualiza el pedido sin poder editarlo */}
      <Modal size="xl" isOpen={modalVer} toggle={toggleVer} style={{ maxWidth: "90%", margin: "0 auto" }}>
        <ModalHeader toggle={toggleVer}>
          <h4>Pedido {verPedido?.numero} — {verPedido?.clientes}</h4>
        </ModalHeader>
        <ModalBody>
          {verPedido && (
            <>
              <Row>
                <Col md={2}>
                  <Label className="negrita">Fecha</Label>
                  <p>{verPedido.fecha}</p>
                </Col>
                <Col md={2}>
                  <Label className="negrita">Fecha Inicio</Label>
                  <p>{verPedido.fechaInicio || "NA"}</p>
                </Col>
                <Col md={2}>
                  <Label className="negrita">Vendedor</Label>
                  <p>{verPedido.colaboradores}</p>
                </Col>
                <Col md={2}>
                  <Label className="negrita">Paqueteria</Label>
                  <p>{verPedido.paqueteria || "NA"}</p>
                </Col>
                <Col md={2}>
                  <Label className="negrita">Status</Label>
                  <p>{verPedido.status} {verPedido.activo === "No" ? "(Cancelado)" : ""}</p>
                </Col>
                <Col md={2}>
                  <Label className="negrita">Surtido</Label>
                  <p>{verPedido.surtido}</p>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Label className="negrita">Observaciones</Label>
                  <p>{verPedido.observaciones || "NA"}</p>
                </Col>
              </Row>
              <Table size="sm" striped borderless className="table-responsive-xl">
                <thead>
                  <tr>
                    <th className="tituloTabla">Codigo</th>
                    <th className="tituloTabla">Articulo</th>
                    <th className="tituloTabla" align="right">Cantidad</th>
                    <th className="tituloTabla" align="right">Precio</th>
                    <th className="tituloTabla" align="right">Desc %</th>
                    <th className="tituloTabla" align="right">Total</th>
                    <th className="tituloTabla" align="right">Pendiente Surtir</th>
                  </tr>
                </thead>
                <tbody>
                  {verCargando && (
                    <tr>
                      <td colSpan="7" align="center">Cargando artículos…</td>
                    </tr>
                  )}
                  {!verCargando &&
                    verArticulos
                      .filter((x) => x.is_active === "Si")
                      .map((x) => (
                        <tr key={x.id}>
                          <td>{x.codigo}</td>
                          <td>{x.nombre}</td>
                          <td align="right">{new Intl.NumberFormat("en-US").format(x.cantidad)}</td>
                          <td align="right">
                            {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(x.precio)}
                          </td>
                          <td align="right">{x.descuento}%</td>
                          <td align="right">
                            {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(x.total)}
                          </td>
                          <td align="right">{new Intl.NumberFormat("en-US").format(x.pendiente_surtir)}</td>
                        </tr>
                      ))}
                  {!verCargando && verArticulos.filter((x) => x.is_active === "Si").length === 0 && (
                    <tr>
                      <td colSpan="7" align="center">Sin artículos activos</td>
                    </tr>
                  )}
                  <tr>
                    <td></td>
                    <td></td>
                    <td align="right" className="negrita">
                      {new Intl.NumberFormat("en-US").format(verPedido.total_cantidad || 0)}
                    </td>
                    <td></td>
                    <td className="negrita" align="right">SubTotal</td>
                    <td className="negrita" align="right">
                      {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(verPedido.subTotal || 0)}
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td><td></td><td></td><td></td>
                    <td className="negrita" align="right">IVA ({verPedido.impuestos || 0}%)</td>
                    <td className="negrita" align="right">
                      {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(verPedido.iva || 0)}
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td><td></td><td></td><td></td>
                    <td className="negrita" align="right">Total</td>
                    <td className="negrita" align="right">
                      {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(verPedido.total_general || 0)}
                    </td>
                    <td></td>
                  </tr>
                </tbody>
              </Table>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleVer}>Cerrar</Button>
        </ModalFooter>
      </Modal>

      <Modal size="lg" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>Editar Pedido {numero_pedido}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={4}>
              <Label>Cliente</Label>
              <Input
                type="select"
                value={selectedClienteEdit}
                onChange={(e) => setSelectedClienteEdit(e.target.value)}
              >
                <option value="">Selecciona</option>
                {clientes
                  .filter((c) => c.is_active === "Si")
                  .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                  .map((c) => (
                    <option key={c._id} value={c._id}>
                      {c.codigo} {c.nombre_comercial}
                    </option>
                  ))}
              </Input>
            </Col>
            <Col md={3}>
              <Label>Paqueteria</Label>
              <Input
                type="select"
                value={paqueteria}
                required
                onChange={(e) => {
                  setPaqueteria(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                {paqueterias
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((p) => (
                    <option key={p._id} value={p.name}>
                      {p.name}
                    </option>
                  ))}
              </Input>
            </Col>
            <Col md={3}>
              <Label>Fecha Programada</Label>
              <Input
                type="date"
                value={fechaProgramadaEdit}
                onChange={(e) => setFechaProgramadaEdit(e.target.value)}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Label for="exampleEmail" className="mr-sm-2">
                Observaciones
              </Label>
              <Input
                type="textarea"
                placeholder="Observaciones"
                value={observaciones}
                required
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editPedidos}>
            Guardar
          </Button>
          {/* V20: editar artículos desde el mismo flujo de edit */}
          <Button
            color="info"
            onClick={() => {
              const a = currentEditPedidoRow;
              if (!a) return;
              toggleEdit();
              EditArticulos(
                a._id,
                a.numero,
                a.comisionTDC,
                a.comisionFlete,
                a.impuestos,
                a.subTotal,
                a.iva,
                a.total_general,
                a.total_cantidad,
                a.surtido,
                a.clientes,
                a.idClientes,
                a.fechaModificado,
                a.fecha,
                a.descuento,
                a.listaPrecios
              );
            }}
          >
            Editar Artículos
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modalCambiaPrecio} toggle={toggleCambiaPrecio}>
        <ModalHeader toggle={toggleCambiaPrecio}>
          <h4>Autorizar Cambio de Precio</h4>
        </ModalHeader>
        <ModalBody>
          <Input
            bsSize="sm"
            type="password"
            placeholder="Password"
            value={password}
            required
            onChange={(event) => setPassword(event.target.value)}
          />
          <br />
          <Row>
            <Col>
              <Button
                type="submit"
                className="btn btn-success"
                onClick={(e) => autorizaCambio()}
              >
                Autorizar
              </Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>Progreso</h4>
        </ModalHeader>
        <ModalBody>
          <h4>
            {" "}
            Este proceso puede tardar varios segundos.
            <br />
            Por favor no cierre ni refresque su navegador.
          </h4>
          <br />
          <div className="progreso">
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
          </div>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalNoDisponible} toggle={toggleNoDisponible}>
        <ModalHeader toggle={toggleNoDisponible}>
          <h4>No hay Inventario Disponible</h4>
        </ModalHeader>
        <ModalBody>
          <Table size="sm" striped borderless className="table-responsive-xl">
            <tr>
              <th>Articulo</th>
              <th>Pedido</th>
              <th>Disponible</th>
            </tr>

            {allArticulosAutorizar.map((a) => {
              if (a.disponible < a.cantidadPedido) {
                return (
                  <tr style={{ backgroundColor: "#ed8c8c" }}>
                    <td>{a.articuloNombre}</td>
                    <td>
                      {new Intl.NumberFormat("en-US").format(a.cantidadPedido)}
                    </td>
                    <td>
                      {new Intl.NumberFormat("en-US").format(a.disponible)}
                    </td>
                  </tr>
                );
              } else {
                return (
                  <tr>
                    <td>{a.articuloNombre}</td>
                    <td>
                      {new Intl.NumberFormat("en-US").format(a.cantidadPedido)}
                    </td>
                    <td>
                      {new Intl.NumberFormat("en-US").format(a.disponible)}
                    </td>
                  </tr>
                );
              }
            })}
          </Table>
        </ModalBody>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoPedidos;
